window.theme = window.theme || {};
window.slate = window.slate || {};

/* ================ SLATE ================ */
/**
 * Media query helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help with media queries.
 *
 * @namespace MediaQuery
 */
slate.MediaQuery = {
  extra_small: 550,
  small: 750,
  medium: 992,
  large: 1200,
  widescreen: 1400,

  /**
   * Initializer
   * @returns {MediaQuery}
   */
  init: function()
  {
    this.queries = {
      extra_small: '(max-width: ' + (this.extra_small - 1) + 'px)',
      small: '(max-width: ' + (this.medium - 1) + 'px)',
      medium: '(min-width: ' + this.medium + 'px) and (max-width: ' + (this.large - 1) + 'px)',
      medium_down: '(max-width: ' + (this.large - 1) + 'px)',
      medium_up: '(min-width: ' + this.medium + 'px)',
      large: '(min-width: ' + this.large + 'px) and (max-width: ' + (this.widescreen - 1) + 'px)',
      large_down: '(max-width: ' + (this.large - 1) + 'px)',
      large_up: '(min-width: ' + (this.large) + 'px)',
      widescreen: '(min-width: ' + (this.widescreen) + 'px)'
    };

    return this;
  },

  /**
   * Match media queries
   * @param breakpointName
   * @returns {*}
   */
  match: function (breakpointName) {
    if (!breakpointName || !window.matchMedia) {
      return null;
    }

    var mediaQuery = this.queries[breakpointName];
    return window.matchMedia(mediaQuery);
  }
}.init();
/**
 * Form helpers
 * -----------------------------------------------------------------------------
 * A collection of functions that help with Form operations.
 *
 * @namespace forms
 */

slate.forms = {
  /**
   * Create custom select boxes
   */
  initCustomSelects: function () {
    var selects = $('select:not(".no-js")');
    $(selects).each(function() {
      $(this).wrap('<div class="select">')
        .parent()
        .prepend('<span class="icon-select"></span>');
    });
  },

  /**
   * Initialize contact forms
   * @private
   */
  initContactForms: function () {
    var form_type = slate.utils.getUrlParameter("form_type");

    // Contact form
    if(form_type === 'contact') {
      $("input[name='form_type'][value='contact']").closest('form').find('.errors').show();
    }

    // Newsletter form
    if(form_type === 'customer') {
      $("input[name='form_type'][value='customer']").closest('form').find('.errors').show();
      $('html, body').animate({scrollTop:$(document).height()}, 'fast');
    }
  }
};
/**
 * A11y helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help make your theme more accessible
 * to users with visual impairments.
 *
 * @namespace a11y
 */

slate.a11y = {
  /**
   * For use when focus shifts to a container rather than a link
   * eg for In-page links, after scroll, focus shifts to content area so that
   * next `tab` is where user expects if focusing a link, just $link.focus();
   *
   * @param {JQuery} $element - The element to be acted upon
   */
  pageLinkFocus: function ($element) {
    var focusClass = 'js-focus-hidden';

    $element.first()
      .attr('tabIndex', '-1')
      .focus()
      .addClass(focusClass)
      .one('blur', callback);

    function callback() {
      $element.first()
        .removeClass(focusClass)
        .removeAttr('tabindex');
    }
  },

  /**
   * If there's a hash in the url, focus the appropriate element
   */
  focusHash: function () {
    var hash = window.location.hash;

    // is there a hash in the url? is it an element on the page?
    if (hash && document.getElementById(hash.slice(1))) {
      this.pageLinkFocus($(hash));
    }
  },

  /**
   * When an in-page (url w/hash) link is clicked, focus the appropriate element
   */
  bindInPageLinks: function () {
    $('a[href*=#]').on('click', function (evt) {
      this.pageLinkFocus($(evt.currentTarget.hash));
    }.bind(this));
  },

  /**
   * Traps the focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {jQuery} options.$elementToFocus - Element to be focused when focus leaves container
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  trapFocus: function (options) {
    var eventName = options.eventNamespace
      ? 'focusin.' + options.eventNamespace
      : 'focusin';

    if (!options.$elementToFocus) {
      options.$elementToFocus = options.$container;
    }

    options.$container.attr('tabindex', '-1');
    options.$elementToFocus.focus();

    $(document).on(eventName, function (evt) {
      if (options.$container[0] !== evt.target && !options.$container.has(evt.target).length) {
        options.$container.focus();
      }
    });
  },

  /**
   * Removes the trap of focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  removeTrapFocus: function (options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (options.$container && options.$container.length) {
      options.$container.removeAttr('tabindex');
    }

    $(document).off(eventName);
  }
};
/**
 * Utility helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions for dealing with arrays and objects
 *
 * @namespace utils
 */

slate.utils = {
  /**
   * Returns querystring parameter
   *
   * @param name
   * @returns {string}
   */
  getUrlParameter: function(name) {
    name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
    var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
    var results = regex.exec(location.search);

    return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
  },

  /**
   * Return an object from an array of objects that matches the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  findInstance: function (array, key, value) {
    for (var i = 0; i < array.length; i++) {
      if (array[i][key] === value) {
        return array[i];
      }
    }
  },

  /**
   * Remove an object from an array of objects by matching the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  removeInstance: function (array, key, value) {
    var i = array.length;
    while (i--) {
      if (array[i][key] === value) {
        array.splice(i, 1);
        break;
      }
    }

    return array;
  },

  /**
   * _.compact from lodash
   * Remove empty/false items from array
   * Source: https://github.com/lodash/lodash/blob/master/compact.js
   *
   * @param {array} array
   */
  compact: function (array) {
    var index = -1;
    var length = array == null ? 0 : array.length;
    var resIndex = 0;
    var result = [];

    while (++index < length) {
      var value = array[index];
      if (value) {
        result[resIndex++] = value;
      }
    }
    return result;
  }
};

/**
 * RTE helpers
 * -----------------------------------------------------------------------------
 * A collection of functions that help with RTE operations.
 *
 * @namespace rte
 */

slate.rte = {
  /**
   * Wrap videos in div to force responsive layout.
   */
  wrapTable: function () {
    $('.rte table').wrap('<div class="rte__table-wrapper"></div>');
  },

  /**
   * Reset iframe src
   */
  iframeReset: function () {
    var $iframeVideo = $('.rte iframe[src*="youtube.com/embed"], .rte iframe[src*="player.vimeo"]');
    var $iframeReset = $iframeVideo.add('.rte iframe#admin_bar_iframe');

    $iframeVideo.each(function () {
      // Add wrapper to make video responsive
      $(this).wrap('<div class="video-wrapper"></div>');
    });

    $iframeReset.each(function () {
      // Re-set the src attribute on each iframe after page load
      // for Chrome's "incorrect iFrame content on 'back'" bug.
      // https://code.google.com/p/chromium/issues/detail?id=395791
      // Need to specifically target video and admin bar
      this.src = this.src;
    });
  }
};
/**
 * Section helpers
 * -----------------------------------------------------------------------------
 * Creates section events.
 *
 * @namespace Sections
 */

slate.Sections = function Sections() {
  this.constructors = {};
  this.instances = [];

  $(document)
    .on('shopify:section:load', this._onSectionLoad.bind(this))
    .on('shopify:section:unload', this._onSectionUnload.bind(this))
    .on('shopify:section:select', this._onSelect.bind(this))
    .on('shopify:section:deselect', this._onDeselect.bind(this))
    .on('shopify:block:select', this._onBlockSelect.bind(this))
    .on('shopify:block:deselect', this._onBlockDeselect.bind(this));
};

slate.Sections.prototype = $.extend({}, slate.Sections.prototype, {
  _createInstance: function (container, constructor) {
    var $container = $(container);
    var id = $container.attr('data-section-id');
    var type = $container.attr('data-section-type');

    constructor = constructor || this.constructors[type];

    if (typeof constructor === 'undefined') {
      return;
    }

    var instance = $.extend(new constructor(container), {
      id: id,
      type: type,
      container: container
    });

    this.instances.push(instance);
  },

  _onSectionLoad: function (evt) {
    var container = $('[data-section-id]', evt.target)[0];
    if (container) {
      this._createInstance(container);
    }
  },

  _onSectionUnload: function (evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (!instance) {
      return;
    }

    if (typeof instance.onUnload === 'function') {
      instance.onUnload(evt);
    }

    this.instances = slate.utils.removeInstance(this.instances, 'id', evt.detail.sectionId);
  },

  _onSelect: function (evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onSelect === 'function') {
      instance.onSelect(evt);
    }
  },

  _onDeselect: function (evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onDeselect === 'function') {
      instance.onDeselect(evt);
    }
  },

  _onBlockSelect: function (evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onBlockSelect === 'function') {
      instance.onBlockSelect(evt);
    }
  },

  _onBlockDeselect: function (evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onBlockDeselect === 'function') {
      instance.onBlockDeselect(evt);
    }
  },

  register: function (type, constructor) {
    this.constructors[type] = constructor;

    $('[data-section-type=' + type + ']').each(function (index, container) {
      this._createInstance(container, constructor);
    }.bind(this));
  }
});

/**
 * Currency helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help with currency formatting
 *
 * Current contents
 * - formatMoney - Takes an amount in cents and returns it as a formatted dollar value.
 *
 * Alternatives
 * - Accounting.js - http://openexchangerates.github.io/accounting.js/
 *
 * @namespace Currency
 */

theme.Currency = (function () {
  var moneyFormat = '${{amount}}'; // eslint-disable-line camelcase

  /**
   * Format money values based on your shop currency settings
   * @param  {Number|string} cents - value in cents or dollar amount e.g. 300 cents
   * or 3.00 dollars
   * @param  {String} format - shop money_format setting
   * @return {String} value - formatted value
   */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = (format || moneyFormat);

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = precision || 2;
      thousands = thousands || ',';
      decimal = decimal || '.';

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      var parts = number.split('.');
      var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsAmount = parts[1] ? (decimal + parts[1]) : '';

      return dollarsAmount + centsAmount;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = formatWithDelimiters(cents, 0, ' ');
        break;
    }

    return formatString.replace(placeholderRegex, value);
  }

  return {
    formatMoney: formatMoney
  };
})();
/**
 * Image helpers
 * -----------------------------------------------------------------------------
 * A collection of functions that help with basic image operations.
 *
 * @namespace Images
 */
theme.Images = (function () {
  /**
   * Preloads an image in memory and uses the browsers cache to store it until needed.
   *
   * @param {Array} images - A list of image urls
   * @param {String} size - A shopify image size attribute
   */
  function preload(images, size) {
    if (typeof images === 'string') {
      images = [images];
    }

    for (var i = 0; i < images.length; i++) {
      var image = images[i];
      this.loadImage(this.getSizedImageUrl(image, size));
    }
  }

  /**
   * Loads and caches an image in the browsers cache.
   * @param {string} path - An image url
   */
  function loadImage(path) {
    new Image().src = path;
  }

  /**
   * Swaps the src of an image for another OR returns the imageURL to the callback function
   * @param image
   * @param element
   * @param callback
   */
  function switchImage(image, element, callback) {
    var size = this.imageSize(element.src);
    var imageUrl = this.getSizedImageUrl(image.src, size);

    if (callback) {
      callback(imageUrl, image, element); // eslint-disable-line callback-return
    } else {
      element.src = imageUrl;
    }
  }

  /**
   * +++ Useful
   * Find the Shopify image attribute size
   *
   * @param {string} src
   * @returns {null}
   */
  function imageSize(src) {
    var match = src.match(/.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/);

    if (match === null) {
      return null;
    } else {
      return match[1];
    }
  }

  /**
   * +++ Useful
   * Adds a Shopify size attribute to a URL
   *
   * @param src
   * @param size
   * @returns {*}
   */
  function getSizedImageUrl(src, size) {
    if (size == null) {
      return src;
    }

    if (size === 'master') {
      return this.removeProtocol(src);
    }

    var match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);

    if (match != null) {
      var prefix = src.split(match[0]);
      var suffix = match[0];

      return this.removeProtocol(prefix[0] + '_' + size + suffix);
    }

    return null;
  }

  function removeProtocol(path) {
    return path.replace(/http(s)?:/, '');
  }

  return {
    preload: preload,
    loadImage: loadImage,
    switchImage: switchImage,
    imageSize: imageSize,
    getSizedImageUrl: getSizedImageUrl,
    removeProtocol: removeProtocol
  };
})();
/**
 * Variants helpers
 * ------------------------------------------------------------------------------
 *
 * Handles change events from the variant inputs in any `cart/add` forms that may
 * exist.  Also updates the master select and triggers updates when the variants
 * price or image changes.
 *
 * @namespace Variants
 */

slate.Variants = (function () {
  /**
   * Variant constructor
   *
   * @param {object} options - Settings from `product.js`
   */
  function Variants(options) {
    this.$container = options.$container;
    this.product = options.product;
    this.singleOptionSelector = options.singleOptionSelector;
    this.originalSelectorId = options.originalSelectorId;
    this.enableHistoryState = options.enableHistoryState;
    this.currentVariant = this._getVariantFromOptions();

    $(this.singleOptionSelector, this.$container).on('change', this._onSelectChange.bind(this));
  }

  Variants.prototype = $.extend({}, Variants.prototype, {

    /**
     * Get the currently selected options from add-to-cart form. Works with all
     * form input elements.
     *
     * @return {array} options - Values of currently selected variants
     */
    _getCurrentOptions: function () {
      var currentOptions = $.map($(this.singleOptionSelector, this.$container), function (element) {
        var $element = $(element);
        var type = $element.attr('type');
        var currentOption = {};

        if (type === 'radio' || type === 'checkbox') {
          if ($element[0].checked) {
            currentOption.value = $element.val();
            currentOption.index = $element.data('index');

            return currentOption;
          } else {
            return false;
          }
        } else {
          currentOption.value = $element.val();
          currentOption.index = $element.data('index');

          return currentOption;
        }
      });

      // remove any unchecked input values if using radio buttons or checkboxes
      currentOptions = slate.utils.compact(currentOptions);

      return currentOptions;
    },

    /**
     * Find variant based on selected values.
     *
     * @param  {array} selectedValues - Values of variant inputs
     * @return {object || undefined} found - Variant object from product.variants
     */
    _getVariantFromOptions: function () {
      var selectedValues = this._getCurrentOptions();
      var variants = this.product.variants;
      var found = false;

      variants.forEach(function (variant) {
        var satisfied = true;
        var options = variant.options;

        selectedValues.forEach(function (option) {
          if (satisfied) {
            satisfied = (option.value === variant[option.index]);
          }
        });

        if (satisfied) {
          found = variant;
        }
      });

      return found || null;
    },

    /**
     * Event handler for when a variant input changes.
     */
    _onSelectChange: function () {
      var variant = this._getVariantFromOptions();

      this.$container.trigger({
        type: 'variantChange',
        variant: variant
      });

      if (!variant) {
        return;
      }

      this._updateMasterSelect(variant);
      this._updateImages(variant);
      this._updatePrice(variant);
      this._updateSKU(variant);
      this.currentVariant = variant;

      if (this.enableHistoryState) {
        this._updateHistoryState(variant);
      }
    },

    /**
     * Trigger event when variant image changes
     *
     * @param  {object} variant - Currently selected variant
     * @return {event}  variantImageChange
     */
    _updateImages: function (variant) {
      var variantImage = variant.featured_image || {};
      var currentVariantImage = this.currentVariant.featured_image || {};

      if (!variant.featured_image || variantImage.src === currentVariantImage.src) {
        return;
      }

      this.$container.trigger({
        type: 'variantImageChange',
        variant: variant
      });
    },

    /**
     * Trigger event when variant price changes.
     *
     * @param  {object} variant - Currently selected variant
     * @return {event} variantPriceChange
     */
    _updatePrice: function (variant) {
      if (variant.price === this.currentVariant.price && variant.compare_at_price === this.currentVariant.compare_at_price) {
        return;
      }

      this.$container.trigger({
        type: 'variantPriceChange',
        variant: variant
      });
    },

    /**
     * Trigger event when variant sku changes.
     *
     * @param  {object} variant - Currently selected variant
     * @return {event} variantSKUChange
     */
    _updateSKU: function (variant) {
      if (variant.sku === this.currentVariant.sku) {
        return;
      }

      this.$container.trigger({
        type: 'variantSKUChange',
        variant: variant
      });
    },

    /**
     * Update history state for product deeplinking
     *
     * @param  {variant} variant - Currently selected variant
     * @return {k}         [description]
     */
    _updateHistoryState: function (variant) {
      if (!history.replaceState || !variant) {
        return;
      }

      var newurl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?variant=' + variant.id;
      window.history.replaceState({path: newurl}, '', newurl);
    },

    /**
     * Update hidden master select of variant change
     *
     * @param  {variant} variant - Currently selected variant
     */
    _updateMasterSelect: function (variant) {
      $(this.originalSelectorId, this.$container).val(variant.id);
    }
  });

  return Variants;
})();

/*================ MODULES ================*/
/**
 * Drawers module
 * ------------------------------------------------------------------------------
 * Controls drawers dropdown functionality.
 *
 * @namespace Drawers
 */

window.Drawers = (function () {
  /**
   * Create drawer
   * @param id
   * @param position
   * @param options
   * @returns {boolean}
   * @constructor
   */
  var Drawer = function (id, position, options) {
    var defaults = {
      overlay: 'drawer__overlay',
      close: '.js-drawer-close',
      open: '.js-drawer-open-' + position,
      openClass: 'js-drawer-open',
      dirOpenClass: 'js-drawer-open-' + position
    };

    this.$nodes = {
      window: $(window),
      parent: $('body'),
      scroll: $('html, body'),
      moved: $('.is-moved-by-drawer')
    };

    this.config = $.extend(defaults, options);
    this.position = position;
    this.$drawer = $('#' + id);
    this.$open = $(this.config.open);

    if (!this.$drawer.length) {
      return false;
    }

    this.drawerIsOpen = false;
    this.init();
  };

  /**
   * Initialize drawer
   */
  Drawer.prototype.init = function () {
    this.mediaMatch = slate.MediaQuery.match('medium_up');
    this.$nodes.parent.append($('<div>', {class: this.config.overlay}));
    this.$overlay = $('.' + this.config.overlay);
    this.$overlay.on('click', $.proxy(this.close, this));
    this.$open.attr('aria-expanded', 'false');
    this.$open.on('click', $.proxy(this.open, this));
    this.$drawer.find(this.config.close).on('click', $.proxy(this.close, this));
  };

  /**
   * Open drawer
   * @param evt
   */
  Drawer.prototype.open = function (evt) {
    // don't open an opened drawer
    if (this.drawerIsOpen)
      return;

    // Prevent following href if link is clicked
    if (evt) {
      evt.preventDefault();
    }

    // Set classes
    this.$open.addClass(this.config.openClass);
    this.$nodes.scroll.addClass('scroll-lock');
    this.$nodes.moved.addClass('is-transitioning');
    this.$drawer.prepareTransition();
    this.$nodes.parent.addClass(this.config.openClass + ' ' + this.config.dirOpenClass);
    this.drawerIsOpen = true;

    // Set focus on drawer
    slate.a11y.trapFocus({ $container: this.$drawer, namespace: 'drawer_focus' });

    this.$overlay.show();
    this.bindEvents();
  };

  /**
   * Close drawer
   */
  Drawer.prototype.close = function () {
    // don't close a closed drawer
    if (!this.drawerIsOpen) {
      return;
    }

    // Blur acive element
    $(document.activeElement).trigger('blur');

    // Set classes
    this.$open.removeClass(this.config.openClass);
    this.$nodes.scroll.removeClass('scroll-lock');
    this.$nodes.moved.prepareTransition({disableExisting: true});
    this.$drawer.prepareTransition({disableExisting: true});
    this.$nodes.parent.removeClass(this.config.dirOpenClass + ' ' + this.config.openClass);
    this.drawerIsOpen = false;

    // Remove focus on drawer
    slate.a11y.removeTrapFocus({ $container: this.$drawer, namespace: 'drawer_focus' });

    // Hide overlay
    this.$overlay.hide();
    this.unbindEvents();
  };

  /**
   * Match media
   * @param mql
   */
  Drawer.prototype.onMediaMatch = function (mql) {
    if(mql.matches) {
      this.close();
    }
  };

  /**
   * Bind events
   */
  Drawer.prototype.bindEvents = function () {
    // Lock scrolling on mobile
    this.$nodes.parent.on('touchmove.drawer', function () {
      return false;
    });

    // Pressing escape closes drawer
    this.$nodes.parent.on('keyup.drawer', $.proxy(function (evt) {
      if (evt.keyCode === 27) {
        this.close();
      }
    }, this));

    // Media matching
    this.mediaMatch.addListener(this.onMediaMatch.bind(this));
  };

  /**
   * Unbind events
   */
  Drawer.prototype.unbindEvents = function () {
    this.$nodes.parent.off('.drawer');
    this.mediaMatch.removeListener(this.onMediaMatch);
  };

  return Drawer;
})();
/**
 * Hero module
 * ------------------------------------------------------------------------------
 * Controls hero functionality.
 *
 * @namespace Hero
 */

theme.Hero = (function () {
  var selectors = {
    hero: '.hero',
    heroWrapper: '.hero-wrapper',
    heroArrows: '.hero__arrow',
    heroImage: '.hero__image',
    heroPause: '.hero__pause'
  };

  /**
   * Create hero
   * @constructor
   */
  function Hero() {
    this.namespace = '.hero';
    this.$hero = $(selectors.hero);

    this.$hero.slick({
      arrows: false,
      autoplay: this.$hero.data('autoplay'),
      autoplaySpeed: this.$hero.data('speed')
    });
  }

  Hero.prototype = $.extend({}, Hero.prototype, {
    /**
     * Pause slider
     * @private
     */
    _pause: function () {
      this.$hero.slick('slickPause');
      $(selectors.heroPause).addClass('is-paused');
    },

    /**
     * Play slider
     * @private
     */
    _play: function () {
      this.$hero.slick('slickPlay');
      $(selectors.heroPause).removeClass('is-paused');
    },

    /**
     * Go to slide
     * @param slideIndex
     */
    goToSlide: function (slideIndex) {
      this.$hero.slick('slickGoTo', slideIndex);
    },

    /**
     * Pause slider
     */
    pause: function () {
      this.$hero.slick('slickPause');
    },

    /**
     * Play slider
     */
    play: function () {
      this.$hero.slick('slickPlay');
    },

    /**
     * Destroy slider
     */
    destroy: function () {
      this.$hero.off(this.namespace);
      $(selectors.heroImage).off(this.namespace);
      $(selectors.heroPause).off(this.namespace);
      $(selectors.heroWrapper).off(this.namespace);
      $(selectors.heroArrows).off(this.namespace);

      this.$hero.slick('unslick');
    }
  });

  return Hero;
})();
/**
 * Modals module
 * ------------------------------------------------------------------------------
 * Controls modals functionality.
 *
 * @namespace Modals
 */

window.Modals = (function () {
  /**
   * Create modal
   * @param id
   * @param name
   * @param options
   * @returns {boolean}
   * @constructor
   */
  var Modal = function (id, name, options) {
    var defaults = {
      close: '.js-modal-close',
      open: '.js-modal-open-' + name,
      openClass: 'modal--is-active'
    };

    this.$modal = $('#' + id);

    if (!this.$modal.length) {
      return false;
    }

    this.$nodes = {
      body: $('body')
    };

    this.config = $.extend(defaults, options);
    this.modalIsOpen = false;
    this.focusOnOpen = this.config.focusOnOpen ? $(this.config.focusOnOpen) : this.$modal;
    this.init();
  };

  /**
   * Initialize
   */
  Modal.prototype.init = function () {
    var $openBtn = $(this.config.open);
    $openBtn.attr('aria-expanded', 'false');
    $(this.config.open).on('click', $.proxy(this.open, this));
    this.$modal.find(this.config.close).on('click', $.proxy(this.close, this));
  };

  /**
   * Open modal
   * @param evt
   */
  Modal.prototype.open = function (evt) {
    // don't open an opened modal
    if (this.modalIsOpen) {
      return;
    }

    // Prevent following href if link is clicked
    if (evt) {
      evt.preventDefault();
    }

    // Set classes
    this.$modal.prepareTransition().addClass(this.config.openClass);
    this.$nodes.body.addClass(this.config.openClass);
    this.modalIsOpen = true;

    // Set focus on modal
    slate.a11y.trapFocus({ $container: this.$modal, namespace: 'modal_focus', $elementToFocus: this.focusOnOpen });

    this.bindEvents();
  };

  /**
   * Close
   */
  Modal.prototype.close = function () {
    // don't close a closed modal
    if (!this.modalIsOpen) {
      return;
    }

    // Blur acive element
    $(document.activeElement).trigger('blur');

    // Set classes
    this.$modal.prepareTransition().removeClass(this.config.openClass);
    this.$nodes.body.removeClass(this.config.openClass);
    this.modalIsOpen = false;

    // Remove focus on modal
    slate.a11y.removeTrapFocus({ $container: this.$modal, namespace: 'modal_focus' });

    this.unbindEvents();
  };

  /**
   * Bind events
   */
  Modal.prototype.bindEvents = function () {
    // Pressing escape closes modal
    this.$nodes.body.on('keyup.modal', $.proxy(function (evt) {
      if (evt.keyCode === 27) {
        this.close();
      }
    }, this));
  };

  /**
   * Unbind events
   */
  Modal.prototype.unbindEvents = function () {
    this.$nodes.body.off('.modal');
  };

  return Modal;
})();
/**
 * Meganav module
 * ------------------------------------------------------------------------------
 * Controls meganav functionality.
 *
 * @namespace Meganav
 */

window.Meganav = (function () {
  /**
   * Create meganav
   * @param options
   * @constructor
   */
  var Meganav = function (options) {
    this.cache = {
      $document: $(document),
      $window:  $(window),
      $page: $('.page-element')
    };

    var defaults = {
      $meganavs: $('.meganav'),
      $meganavToggle: $('.meganav-toggle'),
      isOpen: false,
      preventDuplicates: false,
      closeOnPageClick: false,
      openEvent: 'click',
      activeClass: 'meganav--active',
      noAnimationClass: 'meganav--no-animation'
    };

    this.config = $.extend(defaults, options);
    this.init();
  };

  /**
   * Initialize
   */
  Meganav.prototype.init = function () {
    var $openBtn = this.config.$meganavToggle;

    // Add aria controls
    $openBtn.attr('aria-expanded', 'false');
    $openBtn.each(function (i, el) {
      var $el = $(el);
      $el.attr('aria-controls', $el.attr('data-aria-controls'));
    });

    $openBtn.on(this.config.openEvent, $.proxy(this.requestMeganav, this));
  };

  /**
   * Request mega navigation
   * @param evt
   */
  Meganav.prototype.requestMeganav = function (evt) {
    // Prevent following href if link is clicked
    if (evt) {
      evt.preventDefault();
    }

    // Without this, the meganav opens, the click event bubbles up to
    // theme.cache.$page which closes the drawer.
    if (evt && evt.stopPropagation) {
      evt.stopPropagation();
    }

    var $el = $(evt.currentTarget);
    var $targetedMeganav = $('#' + $el.attr('aria-controls'));
    var anotherNavIsOpen = this.config.isOpen;

    // Navigate to link href or close menu if already active
    if ($el.hasClass(this.config.activeClass)) {
      if (this.config.openEvent == 'click') {
        return this.close(evt, $el);
      }
    }

    // If true, don't let multiple meganavs be open simultaneously
    if (this.config.preventDuplicates) {
      this.close();
    }

    // Set active class on toggle button/link
    $el.addClass(this.config.activeClass).attr('aria-expanded', 'true');

    // Show targeted nav, letting it know whether another meganav is already open
    this.open($targetedMeganav, anotherNavIsOpen);

    // Setup event handlers when meganav is open
    this.bindEvents();
    this.config.isOpen = true;
  };

  /**
   * Open meganav
   * @param $target
   * @param noAnimation
   */
  Meganav.prototype.open = function ($target, noAnimation) {
    $target.addClass(this.config.activeClass);

    // Add class to override animation - CSS determined
    if (noAnimation) {
      $target.addClass(this.config.noAnimationClass);
    }
  };

  /**
   * Close meganav
   * @param evt
   * @param $target
   */
  Meganav.prototype.close = function (evt, $target) {
    if (this.config.preventDuplicates) {
      // Close all meganavs
      this.config.$meganavs.removeClass([this.config.activeClass, this.config.noAnimationClass].join(' '));
      this.config.$meganavToggle.removeClass(this.config.activeClass).attr('aria-expanded', 'false');
    } else {
      // Close targeted nav
      var $targetedMeganav = $('#' + $target.attr('aria-controls'));
      $targetedMeganav.removeClass([this.config.activeClass, this.config.noAnimationClass].join(' '));
      $target.removeClass(this.config.activeClass).attr('aria-expanded', 'false');
    }

    // Remove event listeners
    this.unbindEvents();
    this.config.isOpen = false;
  };

  /**
   * Bind events
   */
  Meganav.prototype.bindEvents = function () {
    if (!this.config.closeOnPageClick) {
      return;
    }

    // Clicking away from the meganav will close it
    this.cache.$page.on(this.config.openEvent + '.meganav', $.proxy(this.close, this));

    // Exception to above: clicking anywhere on the meganav will NOT close it
    this.config.$meganavs.on(this.config.openEvent + '.meganav', function (evt) {
      evt.stopImmediatePropagation();
    });

    // Pressing escape closes meganav and focuses the target parent link
    this.cache.$document.on('keyup.meganav', $.proxy(function (evt) {
      if (evt.keyCode === 27) {
        this.config.$meganavToggle.filter('.' + this.config.activeClass).focus();
        this.close();
      }
    }, this));
  };

  /**
   * Unbind events
   */
  Meganav.prototype.unbindEvents = function () {
    if (!this.config.closeOnPageClick) {
      return;
    }

    this.cache.$page.off('.meganav');
    this.config.$meganavs.off('.meganav');
    this.cache.$document.off('.meganav');
  };

  return Meganav;
})();
/**
 * Accordions module
 * ------------------------------------------------------------------------------
 * Controls accordion functionality.
 *
 * @namespace Accordions
 */

window.Accordions = (function () {
  /**
   * Create accordion
   * @param options
   * @constructor
   */
  var Accordion = function (options) {
    var defaults = {
      $accordionToggle: $('.accordion-toggle'),
      accordionButton: 'accordion-button',
      accordionContent: 'accordion-content',
      activeClass: 'accordion--active',
      disableBreakpoint: null,
      resetBreakpoint: null,
      loadExpanded: null
    };

    this.config = $.extend(defaults, options);
    this.$accordionToggle = this.config.$accordionToggle;
    this.init();
  };

  /**
   * Initialize
   */
  Accordion.prototype.init = function () {
    // Add media queries
    this.disableMediaMatch = slate.MediaQuery.match(this.config.disableBreakpoint);
    this.resetMediaMatch = slate.MediaQuery.match(this.config.resetBreakpoint);

    // Add classes
    this.$accordionToggle.each(function (i, el) {
      $(el).addClass(this.config.accordionButton);
      $(el).next().addClass(this.config.accordionContent);
      if (this.config.loadExpanded)
        this.toggleClass($(el));
    }.bind(this));

    // Bind events
    this.bindEvents();
  };

  /**
   * Toggle accordion
   * @param evt
   */
  Accordion.prototype.toggle = function (evt) {
    if(this.disableMediaMatch && this.disableMediaMatch.matches) {
      return;
    }

    if (evt) {
      evt.preventDefault();
    }

    this.toggleClass($(evt.currentTarget));
  };

  /**
   * Toggle accordion class
   * @param el
   */
  Accordion.prototype.toggleClass = function (el) {
    el.toggleClass(this.config.activeClass);
    el.next().toggleClass(this.config.activeClass);
  };

  /**
   * Reset accordion
   */
  Accordion.prototype.reset = function () {
    this.$accordionToggle.each(function (i, el) {
      $(el).removeClass(this.config.activeClass);
      $(el).next().removeClass(this.config.activeClass);
    }.bind(this));
  };

  /**
   * Match media
   * @param mql
   */
  Accordion.prototype.onResetMediaMatch = function (mql) {
    if(mql.matches) {
      this.reset();
    }
  };

  /**
   * Bind events
   */
  Accordion.prototype.bindEvents = function () {
    if(this.resetMediaMatch) {
      this.resetMediaMatch.addListener(this.onResetMediaMatch.bind(this));
    }
    this.$accordionToggle.on('click', $.proxy(this.toggle, this));
  };

  /**
   * Unbind events
   */
  Accordion.prototype.unbindEvents = function () {
    this.$accordionToggle.off();
  };

  return Accordion;
})();
/**
 * Quantity selector module
 * ------------------------------------------------------------------------------
 * Controls cart quantity selector module functionality.
 *
 * @namespace QtySelector
 */

window.QtySelector = (function () {
  /**
   * Quantity selector
   * @param $el
   * @constructor
   */
  var QtySelector = function ($el) {
    this.cache = {
      $body: $('body'),
      $cartHeaderTooltip: $('.site-header__cart'),
      $subtotal: $('#CartSubtotal'),
      $subtotalAffirm: $('#CartSubtotalAffirm'),
      $discountTotal: $('#cartDiscountTotal'),
      $cartTable: $('.cart-table'),
      $cartTemplate: $('#CartProducts')
    };

    this.settings = {
      loadingClass: 'js-qty--is-loading',
      isCartTemplate: this.cache.$body.hasClass('template-cart'),
      // On the cart template, minimum is 0. Elsewhere min is 1
      minQty: this.cache.$body.hasClass('template-cart') ? 0 : 1
    };

    this.$el = $el;
    this.qtyUpdateTimeout;
    this.createInputs();
    this.bindEvents();
  };

  /**
   * Create inputs
   */
  QtySelector.prototype.createInputs = function () {
    var $el = this.$el;

    var data = {
      value: $el.val(),
      key: $el.attr('id'),
      name: $el.attr('name'),
      line: $el.attr('data-line')
    };
    var source = $('#QuantityTemplate').html();
    var template = Handlebars.compile(source);

    this.$wrapper = $(template(data)).insertBefore($el);

    // Remove original number input
    $el.remove();
  };

  /**
   * Validate availability
   * @param line
   * @param quantity
   */
  QtySelector.prototype.validateAvailability = function (line, quantity) {
    var product = theme.cartObject.items[line - 1]; // 0-based index in API
    var handle = product.handle; // needed for the ajax request
    var id = product.id; // needed to find right variant from ajax results

    var params = {
      type: 'GET',
      url: '/products/' + handle + '.js',
      dataType: 'json',
      success: $.proxy(function (cartProduct) {
        this.validateAvailabilityCallback(line, quantity, id, cartProduct);
      }, this)
    };

    $.ajax(params);
  };

  /**
   * Validate availability callback
   * @param line
   * @param quantity
   * @param id
   * @param product
   */
  QtySelector.prototype.validateAvailabilityCallback = function (line, quantity, id, product) {
    var quantityIsAvailable = true;

    // This returns all variants of a product.
    // Loop through them to get our desired one.
    for (var i = 0; i < product.variants.length; i++) {
      var variant = product.variants[i];
      if (variant.id === id) {
        break;
      }
    }

    // If the variant tracks inventory and does not sell when sold out
    // we can compare the requested with available quantity
    if (variant.inventory_management !== null && variant.inventory_policy === 'deny') {
      if (variant.inventory_quantity < quantity) {
        // Show notification with error message
        theme.Notify.open('error', theme.strings.noStockAvailable, true);

        // Set quantity to max amount available
        this.$wrapper.find('.js-qty__input').val(variant.inventory_quantity);

        quantityIsAvailable = false;
        this.$wrapper.removeClass(this.settings.loadingClass);
      }
    }

    if (quantityIsAvailable) {
      this.updateItemQuantity(line, quantity);
    }
  };

  /**
   * Validate quantity
   * @param qty
   * @returns {Number}
   */
  QtySelector.prototype.validateQty = function (qty) {
    if ((parseFloat(qty) === parseInt(qty, 10)) && !isNaN(qty)) {
      // We have a valid number!
    } else {
      // Not a number. Default to 1.
      qty = 1;
    }
    return parseInt(qty, 10);
  };

  /**
   * Adjust quantity
   * @param evt
   */
  QtySelector.prototype.adjustQty = function (evt) {
    var $el = $(evt.currentTarget);
    var $input = $el.siblings('.js-qty__input');
    var qty = this.validateQty($input.val());
    var line = $input.attr('data-line');

    if ($el.hasClass('js-qty__adjust--minus')) {
      qty -= 1;
      if (qty <= this.settings.minQty) {
        qty = this.settings.minQty;
      }
    } else {
      qty += 1;
    }

    if (this.settings.isCartTemplate) {
      $el.parent().addClass(this.settings.loadingClass);
      this.updateCartItemPrice(line, qty);
    } else {
      $input.val(qty);
    }
  };

  /**
   * Bind events
   */
  QtySelector.prototype.bindEvents = function () {
    this.$wrapper.find('.js-qty__adjust').on('click', $.proxy(this.adjustQty, this));

    // Select input text on click
    this.$wrapper.on('click', '.js-qty__input', function () {
      this.setSelectionRange(0, this.value.length);
    });

    // If the quantity changes on the cart template, update the price
    if (this.settings.isCartTemplate) {
      this.$wrapper.on('change', '.js-qty__input', $.proxy(function (evt) {
        var $input = $(evt.currentTarget);
        var line = $input.attr('data-line');
        var qty = this.validateQty($input.val());
        $input.parent().addClass(this.settings.loadingClass);
        this.updateCartItemPrice(line, qty);
      }, this));
    }
  };

  /**
   * Update cart item price
   * @param line
   * @param qty
   */
  QtySelector.prototype.updateCartItemPrice = function (line, qty) {
    // Update cart after short timeout so user doesn't create simultaneous ajax calls
    clearTimeout(this.qtyUpdateTimeout);
    this.qtyUpdateTimeout = setTimeout($.proxy(function () {
      this.validateAvailability(line, qty);
    }, this), 200);
  };

  /**
   * Update item quantity
   * @param line
   * @param quantity
   */
  QtySelector.prototype.updateItemQuantity = function (line, quantity) {
    var params = {
      type: 'POST',
      url: '/cart/change.js',
      data: 'quantity=' + quantity + '&line=' + line,
      dataType: 'json',
      success: $.proxy(function (cart) {
        this.updateCartItemCallback(cart);
      }, this)
    };

    $.ajax(params);
  };

  /**
   * Update cart item callback
   * @param cart
   */
  QtySelector.prototype.updateCartItemCallback = function (cart) {
    // Reload the page to show the empty cart if no items
    if (cart.item_count === 0) {
      location.reload();
      return;
    }

    // Update cart object
    theme.cartObject = cart;

    // Handlebars.js cart layout
    var data = {};
    var items = [];
    var item = {};
    var source = $('#CartProductTemplate').html();
    var template = Handlebars.compile(source);
    var prodImg;

    // Add each item to our handlebars.js data
    $.each(cart.items, function (index, cartItem) {

      /* Hack to get product image thumbnail
       *   - If image is not null
       *     - Remove file extension, add 240x240, and re-add extension
       *     - Create server relative link
       *   - A hard-coded url of no-image
       */

      if (cartItem.image === null) {
        prodImg = '//cdn.shopify.com/s/assets/admin/no-image-medium-cc9732cb976dd349a0df1d39816fbcc7.gif';
      } else {
        prodImg = cartItem.image.replace(/(\.[^.]*)$/, '_240x240$1').replace('http:', '');
      }

      if (cartItem.properties !== null) {
        $.each(cartItem.properties, function (key, value) {
          if (key.charAt(0) === '_' || !value) {
            delete cartItem.properties[key];
          }
        });
      }

      // Create item's data object and add to 'items' array
      item = {
        key: cartItem.key,
        line: index + 1, // Shopify uses a 1+ index in the API
        url: cartItem.url,
        img: prodImg,
        name: cartItem.product_title,
        variation: cartItem.variant_title,
        properties: cartItem.properties,
        itemQty: cartItem.quantity,
        price: theme.Currency.formatMoney(cartItem.price, theme.moneyFormat),
        vendor: cartItem.vendor,
        linePrice: theme.Currency.formatMoney(cartItem.line_price, theme.moneyFormat),
        originalLinePrice: theme.Currency.formatMoney(cartItem.original_line_price, theme.moneyFormat),
        discounts: cartItem.discounts,
        discountsApplied: cartItem.line_price === cartItem.original_line_price ? false : true
      };

      items.push(item);
    });

    // Gather all cart data and add to DOM
    data = {
      items: items
    };
    this.cache.$cartTemplate.empty().append(template(data));

    // Create new quantity selectors
    this.cache.$cartTable.find('input[type="number"]').each(function (i, el) {
      new QtySelector($(el));
    });

    // Update the cart subtotal
    this.cache.$subtotal.html(theme.Currency.formatMoney(cart.total_price, theme.moneyFormat));
    this.cache.$subtotalAffirm.attr('data-amount',cart.total_price);
    this.cache.$cartHeaderTooltip.attr('data-tooltip','Cart (' + cart.item_count + ')');

    // Refresh affirm messaging
    affirm.ui.refresh();

    // Update the cart total discounts
    if (cart.total_discount > 0) {
      this.cache.$discountTotal.html(theme.strings.totalCartDiscount.replace('[savings]', theme.Currency.formatMoney(cart.total_discount, theme.moneyFormat)));
    } else {
      this.cache.$discountTotal.empty();
    }

    // Set focus on cart table
    slate.a11y.pageLinkFocus(this.cache.$cartTable);
  };

  return QtySelector;
})();
/**
 * Ajax cart module
 * ------------------------------------------------------------------------------
 * Allow product to be added to cart via ajax with  custom success and error responses.
 *
 * @namespace AjaxCart
 */

window.AjaxCart = (function () {
  /**
   * Create ajax cart
   * @param $form
   * @constructor
   */
  var cart = function ($form) {
    this.cache = {
      $cartHeaderTooltip: $('.site-header__cart'),
      $cartImage: $('.cart-image'),
      $cartTitle: $('.cart-details--title'),
      $cartOptions: $('.cart-details--options'),
      $cartPrice: $('.cart-details--price'),
      $cartSubtotal: $('.cart--subtotal--price'),
      $cartFooter: $('.cart-footer')
    };

    this.$form = $form;
    this.eventListeners();
  };

  /**
   * Event listeners
   */
  cart.prototype.eventListeners = function () {
    if (this.$form.length) {
      this.$form.on('submit', $.proxy(this.addItemFromForm, this));
    }
  };

  /**
   * Get cart data
   * @returns {*}
   */
  cart.prototype.setCartSummary = function () {
    var params = {
      type: 'GET',
      url: '/cart.js',
      dataType: 'json',
      success: $.proxy(function (data) {
        this.setCartSummarySuccess(data);
      }, this),
      error: $.proxy(function (XMLHttpRequest, textStatus) {
        this.error(XMLHttpRequest, textStatus);
      }, this)
    };

    $.ajax(params);
  };

  /**
   * Add item from form
   * @param evt
   */
  cart.prototype.addItemFromForm = function (evt) {
    evt.preventDefault();
    var params = {
      type: 'POST',
      url: '/cart/add.js',
      data: this.$form.serialize(),
      dataType: 'json',
      success: $.proxy(function (data) {
        this.addItemFromFormSuccess(data);
      }, this),
      error: $.proxy(function (XMLHttpRequest, textStatus) {
        this.error(XMLHttpRequest, textStatus);
      }, this)
    };

    $.ajax(params);
  };

  /**
   * Add cart item success callback
   * @param data
   */
  cart.prototype.addItemFromFormSuccess = function (data) {
    // Images
    if (data.image)
      this.cache.$cartImage.html('<img src="' + data.image + '" alt="' + data.product_title + '">');

    // Update title and options
    this.cache.$cartTitle.text(data.product_title + ' \xD7 ' + data.quantity);
    if (data.variant_options[0] !== 'Title' && data.variant_options[0] !== 'Default Title') {
      this.cache.$cartOptions.text(data.variant_options.join(', '));
    }

    // Update prices
    this.cache.$cartPrice.text(theme.Currency.formatMoney(data.price, theme.moneyFormat));

    // Set cart summary
    this.setCartSummary();
  };

  /**
   * Set cart summmary success callback
   * @param data
   */
  cart.prototype.setCartSummarySuccess = function (data) {
    // Update summary data
    this.cache.$cartSubtotal.text(theme.Currency.formatMoney(data.original_total_price, theme.moneyFormat));
    this.cache.$cartHeaderTooltip.attr('data-tooltip','Cart (' + data.item_count + ')');
    this.cache.$cartFooter.find('span').text(data.item_count);

    // Show notification
    theme.Notify.open('cart', false, false);
  };

  /**
   * Error handling reference from Shopify.onError in api.jquery.js
   * @param XMLHttpRequest
   */
  cart.prototype.error = function (XMLHttpRequest) {
    var data = JSON.parse(XMLHttpRequest.responseText);

    if (!!data.message) {
      theme.Notify.open('error', data.description, true);
    }
  };

  return cart;
})();
/**
 * Autocomplete module
 * ------------------------------------------------------------------------------
 * Allow autocomplete from input via ajax with custom success and error responses.
 *
 * @namespace Autocomplete
 */

window.Autocomplete = (function () {
  /**
   * Create autocomplete
   * @param $el
   * @constructor
   */
  var Autocomplete = function ($el) {
    this.settings = {
      resultsList: 'autocomplete-results',
      resultsListClass: '.autocomplete-results'
    };

    this.$body = $('body');
    this.$scroll = $('html, body');
    this.$form = $el;
    this.hovered = false;
    this.formAction = $el.attr('action');
    this.$formInput = $(this.$form).find('input[name="q"]');
    this.mediaMatch = slate.MediaQuery.match('small');
    this.$resultsList = null;
    this.$closeLink = null;
    this.currentAjaxRequest = null;
    this.ajaxComplete = false;
    this.formSubmitted = false;
    this.init();
  };

  /**
   * Initialize
   */
  Autocomplete.prototype.init = function () {
    // Create list
    var autocompleteHtml = '<ul class="' + this.settings.resultsList + '"></ul>';
    var closeHtml = '<a class="close" href="#">Cancel</a></span>';
    this.$resultsList = $(autocompleteHtml).appendTo(this.$form).hide();
    this.$closeLink = $(closeHtml).appendTo(this.$form);

    // Set event listeners
    this.eventListeners();
  };

  /**
   * Event listeners
   */
  Autocomplete.prototype.eventListeners = function () {
    if (this.$formInput.length) {
      this.$formInput.attr('autocomplete', 'off').on('keyup change', $.proxy(this.getAutocompleteData, this));
      this.$form.on('mouseenter', function(){ this.hovered = true; }.bind(this));
      this.$form.on('mouseleave', function(){ this.hovered = false;}.bind(this));
      this.$form.on('submit', $.proxy(this.submit, this));
      this.$body.on('click', $.proxy(this.close, this));
      this.$closeLink.on("click", $.proxy(this.close, this));
      this.mediaMatch.addListener(this.onMediaMatch.bind(this));
    }
  };

  /**
   * Get autocomplete data
   * @param evt
   */
  Autocomplete.prototype.getAutocompleteData = function (evt) {
    evt.preventDefault();

    // Set variables
    var $input = $(evt.target);
    this.term = $input.val();
    this.ajaxUrl = this.formAction + '?type=product&q=' + this.term + '*';

    // Check if old term is typed
    if (this.term !== $input.attr('data-old-term')) {
      $input.attr('data-old-term', this.term);
      if (this.currentAjaxRequest !== null) this.currentAjaxRequest.abort();

      // Run ajax request
      this.currentAjaxRequest = $.ajax({
        url: this.ajaxUrl + '&view=json',
        dataType: 'json',
        success: $.proxy(function (data) {
          this.success(data);
          this.onMediaMatch(this.mediaMatch);
        }, this)
      });
    }
  };

  /**
   * Success handler
   * @param data
   */
  Autocomplete.prototype.success = function (data) {
    // Clear results
    this.$resultsList.empty();

    // Create autocomplete list
    if(data.results_count === 0) {
      this.$resultsList.hide();
    } else {

      // Get collection from first result
      var collections = data.results[0].collections;
      this.formCollectionLink = this.getCollectionLink(collections);
      console.log(this.formCollectionLink);

      // Build result list
      $.each(data.results, function(index, item) {
        var link = $('<a></a>').attr('href', item.url);
        link.append('<div class="thumbnail"><img src="' + item.thumbnail + '" /></div>');
        link.append('<div class="text"><span class="title">' + item.title + '</span><span class="price">' + item.price + '</span></div>');
        link.wrap('<li></li>');
        this.$resultsList.append(link.parent());
      }.bind(this));

      // Create show all link
      if(data.results_count > 10) {
        this.$resultsList.append('<li><span class="title"><a href="' + this.ajaxUrl + '">See all results (' + data.results_count + ')</a></span></li>');
      }

      // Show autocomplete box
      this.$form.addClass('visible');
      this.$resultsList.fadeIn(200);
      this.ajaxComplete = true;

      // Submit form
      if(this.formSubmitted) {
        this.$form.trigger("submit");
      }
    }
  };

  /**
   * Close dropdown
   */
  Autocomplete.prototype.getCollectionLink = function(result) {
    var url = null;
    $.each(result, function(index, item) {

      var compare = this.term.trim() + ' memorabilia';
      if(item.title.toLowerCase() === compare.toLowerCase()) {
        url = "/collections/" + item.handle;
      }
    }.bind(this));
    return url;
  };

  /**
   * Close dropdown
   */
  Autocomplete.prototype.close = function(evt) {
    var close = $(evt.target).hasClass('close');
    if(!this.hovered || close) {
      this.expand(false);
      this.$resultsList.hide();
      this.$form.removeClass('visible');
    }
  };

  /**
   * Expand dropdown
   * @param state
   */
  Autocomplete.prototype.expand = function(state) {
    if(this.$form.hasClass('visible')) {
      if(state) {
        this.$form.addClass('expanded');
        this.$scroll.addClass('scroll-lock');
      } else {
        this.$form.removeClass('expanded');
        this.$scroll.removeClass('scroll-lock');
      }
    }
  };

  /**
   * Match media
   * @param mql
   */
  Autocomplete.prototype.onMediaMatch = function (mql) {
    if(mql.matches)
      this.expand(true);
    else
      this.expand(false);
  };

  /**
   * Submit form
   * @param evt
   * @returns {boolean}
   */
  Autocomplete.prototype.submit = function(evt) {
    evt.preventDefault();

    this.formSubmitted = true;
    if(this.ajaxComplete) {
      // If collection link is set redirect to collection
      if(this.formCollectionLink) {
        location.href = this.formCollectionLink;
        return false;
      }

      // Clone form and set input
      var $form = $(this.$form).clone().hide();
      var $input = $form.find('[name=q]');
      var input_val = $input.val();

      //Set input string
      $input.val(input_val ? input_val += "*" : input_val);

      // Submit
      this.$body.append($form);
      $form.submit().remove();
    }

    return false;
  };

  /**
   * Unbind events
   */
  Autocomplete.prototype.unbindEvents = function () {
    this.$formInput.off();
    this.mediaMatch.removeListener(this.onMediaMatch);
  };

  return Autocomplete;
})();
/**
 * Notification module
 * ------------------------------------------------------------------------------
 * Controls site notification functionality.
 *
 * @namespace Notify
 */

window.Notify = (function () {
  /**
   * Create notifications
   * @constructor
   */
  var notify = function () {
    this.cache = {
      $notification: $('.notification'),
      $notificationMessage: $('.notification__message'),
      $notificationMessageCart: $('.notification__message--cart'),
      $notificationMessageError: $('.notification__message--error'),
      $notificationClose: $('.notification__close')
    };

    this.settings = {
      notifyActiveClass: 'notification--active',
      closeTimer: 5000
    };

    this.$window = $(window);
    this.$body = $('body');
    this.$header = $('.site-header');
    this.position();
    this.eventListeners();
  };

  /**
   * Event listeners
   */
  notify.prototype.eventListeners = function () {
    this.$window.on('scroll', this.position.bind(this));
    this.$window.on('resize', this.position.bind(this));
    this.cache.$notification.on('mouseenter', function(){ this.hovered = true; }.bind(this));
    this.cache.$notification.on('mouseleave', function(){ this.hovered = false;}.bind(this));
    this.cache.$notificationClose.on('click', $.proxy(this.close, this));
    this.$body.on('click', $.proxy(this.close, this));
  };

  /**
   * Open notifications
   * @param state
   * @param message
   * @param autoclose
   */
  notify.prototype.open = function (state, message, autoclose) {
    // Show notification
    this.cache.$notification
      .attr('aria-hidden', false)
      .addClass(this.settings.notifyActiveClass);

    // Show messages
    if(state === 'cart') {
      this.cache.$notificationMessageCart
        .attr('aria-hidden', false)
        .addClass(this.settings.notifyActiveClass);
    } else if (state === 'error') {
      this.cache.$notificationMessageError
        .attr('aria-hidden', false)
        .addClass(this.settings.notifyActiveClass);

      // Update message
      this.cache.$notificationMessageError.html(message);
    }

    // Timeout to close the notification
    if (autoclose) {
      clearTimeout(this.notifyTimer);
      this.notifyTimer = setTimeout(this.close.bind(this), this.settings.closeTimer);
    }
  };

  /**
   * Position notification
   */
  notify.prototype.position = function () {
    var headerHeight = this.$header.height();
    var topPosition = (headerHeight - window.pageYOffset);

    // Set position
    topPosition = topPosition > 0 ? topPosition : 0;
    this.cache.$notification.css({ top: topPosition });
  };

  /**
   * Close notifications
   * @param evt
   */
  notify.prototype.close = function (evt) {
    var close = $(evt.target).hasClass('close');
    if(!this.hovered || close) {
      this.cache.$notification.attr('aria-hidden', true).removeClass(this.settings.notifyActiveClass);
      this.cache.$notificationMessage.attr('aria-hidden', true).removeClass(this.settings.notifyActiveClass);
    }
  };

  return notify;
})();
/**
 * Filters section
 * ------------------------------------------------------------------------------
 * Controls collection filters and sortables functionality.
 *
 * @namespace Filters
 */

theme.Filters = (function () {
  var selectors = {
    overlayClass: 'filter__overlay',
    filterMenu: '.filter-menu',
    filterElements: '.filter-container',
    filterToggle: '.utils-filter-button',
    filterTagsNav: '.nav-tags-group',
    filterViewAll: '.filter-view-all',
    filterSearch: '.filter-search-box',
    sortSelection: '.sorter__input',
    pageSelection: '.paginate__input'
  };

  /**
   * Create filters
   * @constructor
   */
  function Filters() {
    this.$nodes = {
      window: $(window),
      parent: $('body'),
      scroll: $('html, body')
    };

    this.$filterMenu = $(selectors.filterMenu);
    this.$filterViewAll = $(selectors.filterViewAll);
    this.$filterSearch = $(selectors.filterSearch);
    this.$sortSelect = $(selectors.sortSelection);
    this.$pageSelect = $(selectors.pageSelection);
    this.$sortSelect.val(this._getDefaultSortValue());
    this.$pageSelect.val(this._getDefaultPageValue());
    this.filterWithoutGroups = $(selectors.filterSelection + ' .filter-group').not('.has_group_selected').find(selectors.filterElements);
    this.filterSelect = $(selectors.filterToggle);
    this.tagsMaxItems = this.$filterMenu.data('max-items');

    this._init();
    this._initAccordions();
  }

  Filters.prototype = $.extend({}, Filters.prototype, {

    /**
     * Initialize filter
     * @private
     */
    _init: function() {
      // Overlay
      this.$nodes.parent.append($('<div>', {class: selectors.overlayClass}));
      this.$overlay = $('.' + selectors.overlayClass);

      // Filter events
      this.$overlay.on('click', this._filterClose.bind(this));
      this.filterSelect.on('click', this._filterOpen.bind(this));
      this.$filterViewAll.on('click', $.proxy(this._filterViewAll, this));
      this.$filterSearch.on('keyup blur', $.proxy(this._filterSearch, this));

      // Sort and page events
      this.$sortSelect.on('change', this._onSortChange);
      this.$pageSelect.on('change', this._onPageChange);

      // Responsive events
      this.mediaMatch = slate.MediaQuery.match('small');
      this.mediaMatch.addListener(this._onMediaMatch.bind(this));

      // Toggle filter menu fourps
      if(this.mediaMatch.matches) {
        $(this.filterWithoutGroups).toggle();
      }
    },

    /**
     * Init accordions
     * @private
     */
    _initAccordions: function() {
      new window.Accordions({
        $accordionToggle: $('.filter-menu .accordion-toggle'),
        loadExpanded: true
      });
    },

    /**
     * View all filter items
     * @private
     */
    _filterViewAll: function(evt) {
      var link = $(evt.target);
      var list = link.closest(selectors.filterElements).find(selectors.filterTagsNav);
      var items = list.children('li');
      items.attr("style", "display: block !important;");
      link.hide();
    },

    /**
     * Search filter
     * @private
     */
    _filterSearch: function(evt) {
      var $search_input = $(evt.target);
      var filter = $search_input.val().toUpperCase();
      var container = $search_input.closest(selectors.filterElements);
      var view_all = container.find(selectors.filterViewAll);
      var list = $search_input.next(selectors.filterTagsNav);
      var items = list.children('li');

      // Expand list
      view_all.trigger("click");

      // Hide/show items
      $(items).each(function() {
        var link = $(this).find('a');
        if (link.text().toUpperCase().indexOf(filter) > -1) {
          $(this).show();
        } else {
          $(this).hide();
        }
      });

      // Reset items if no input
      if(filter === "") {
        items.slice(this.tagsMaxItems, items.length).hide();
      }

      // Toggle view all links
      var visible_items = items.filter(':visible');
      if(visible_items.length === this.tagsMaxItems) {
        view_all.show();
      } else {
        view_all.hide();
      }
    },

    /**
     * Open Filter
     * @private
     */
    _filterOpen: function() {
      if(this.mediaMatch.matches) {
        this.$nodes.scroll.addClass('scroll-lock');
        $(this.$overlay).show();
        $(this.$filterMenu).toggleClass('filter-menu--active');
        $(this.filterWithoutGroups).toggle();
      }
    },

    /**
     * Close filter
     * @private
     */
    _filterClose: function() {
      if(this.mediaMatch.matches) {
        this.$nodes.scroll.removeClass('scroll-lock');
        $(this.$overlay).hide();
        $(this.$filterMenu).removeClass('filter-menu--active');
        $(this.filterWithoutGroups).hide();
      }
    },

    /**
     * Get default sort view
     */
    _getDefaultSortValue: function () {
      return Shopify.queryParams.sort_by ? Shopify.queryParams.sort_by : this.$sortSelect.data('default-sort');
    },

    /**
     * Get default page view
     */
    _getDefaultPageValue: function () {
      return Shopify.queryParams.page ? Shopify.queryParams.page : this.$pageSelect.data('default-page');
    },

    /**
     * Sort change event
     */
    _onSortChange: function () {
      Shopify.queryParams.sort_by = $(this).val();
      location.search = $.param(Shopify.queryParams);
    },

    /**
     * Page change event
     */
    _onPageChange: function () {
      Shopify.queryParams.page = $(this).val();
      location.search = $.param(Shopify.queryParams);
    },

    /**
     * Handle matched media
     * @param mql
     * @private
     */
    _onMediaMatch: function(mql) {
      if(mql.matches) {
        $(this.$overlay).hide();
        $(this.$filterMenu).removeClass('filter-menu--active');
        $(this.filterWithoutGroups).hide();
      }
      else {
        this.$nodes.scroll.removeClass('scroll-lock');
        $(this.$overlay).hide();
        $(this.filterWithoutGroups).show();
      }
    },

    /**
     * Unload
     */
    onUnload: function () {
      this.filterSelect.off('click', this._onFilterClick);
      this.$sortSelect.off('change', this._onSortChange);
      this.$pageSelect.off('change', this._onPageChange);
      this.mediaMatch.removeListener(this._onMediaMatch);
    }
  });

  return Filters;
})();
/**
 * Pager section
 * ------------------------------------------------------------------------------
 * Controls collection Pager functionality.
 *
 * @namespace Pager
 */

theme.Pager = (function () {
  var selectors = {
    pagerSelection: '.pager__input'
  };

  /**
   * Create pager
   * @constructor
   */
  function Pager() {
    this.$pagerSelect = $(selectors.pagerSelection);
    this.$pagerSelect.on('change', this._onPagerChange.bind(this));
  }

  Pager.prototype = $.extend({}, Pager.prototype, {

    /**
     * Get default sort view
     */
    _onPagerChange: function () {
      var val = $(this.$pagerSelect).val();

      /* Send the value as a cart attribute via the AJAX API */
      $.ajax({
        type: "POST",
        url: '/cart.js',
        data: {"attributes[pagination]": val},
        success: function(d){
          window.location.reload();
        },
        dataType: 'json'
      });
    },

    /**
     * Unload
     */
    onUnload: function () {
      this.$pagerSelect.off('change', this._onPagerChange);
    }
  });

  return Pager;
})();

/*================ SECTIONS ================*/
/**
 * Header section
 * ------------------------------------------------------------------------------
 * Controls header section functionality.
 *
 * @namespace HeaderSection
 */

theme.HeaderSection = (function () {
  var selectors = {
    siteNav: '#SiteNav',
    siteNavLinks: '#SiteNav li a',
    siteNavLinkMoreText: 'MORE',
    siteNavDropdownMore: '.site-nav__dropdown--more',
    siteNavItemMore: '.site-nav__item--more',
    siteNavLinkMoreRoot: '.site-nav__item--more__root',
    siteNavLinkMore: '.site-nav__link--more',
    siteNavLinkBefore: 'site-nav__link--before'
  };

  /**
   * Header section constructor. Runs on page load as well as Theme Editor
   * `section:load` events.
   */
  function Header(container) {
    this.$container = $(container);
    theme.Notify = new window.Notify();
    theme.NavDrawer = new window.Drawers('NavDrawer', 'left');
    this._init();
  }

  Header.prototype = $.extend({}, Header.prototype, {

    /**
     * Initialize
     */
    _init: function() {
      this._initAutocomplete();
      this._initSiteNav();
      this._initMegaNavs();
      this._initChat();
      this._initRewards();
    },

    _initAutocomplete: function () {
      this.$container.find('.autocomplete').each(function (i, el) {
        // eslint-disable-next-line no-new
        new Autocomplete($(el));
      });
    },

    /**
     * Navigation
     */
    _initSiteNav: function() {
      var $siteNavLastLink = $(selectors.siteNavLinks).last();
      $($siteNavLastLink).addClass('site-nav__link--last');

      this._addSiteNavMoreMenu();
      this._addSiteNavEvents();
    },

    /**
     * Initialize mega navs
     */
    _initMegaNavs: function() {
      new window.Meganav({
        $meganavs: $('.site-nav__dropdown'),
        $meganavToggle: $('.site-nav__meganav-toggle'),
        preventDuplicates: true,
        openEvent: 'mouseover',
        closeOnPageClick: true
      });

      new window.Meganav({
        $meganavs: $('.meganav--index'),
        $meganavToggle: $('.index__meganav-toggle')
      });

      new window.Meganav({
        $meganavs: $('.meganav--drawer'),
        $meganavToggle: $('.drawer__meganav-toggle')
      });
    },

    /**
     * Initialize chat
     */
    _initChat: function() {
      var $chatLink = $('a[href^="#chatlink"]');

      $chatLink.on("click",function(e){
        e.preventDefault();

        if (typeof Tawk_API !== 'undefined') {
          theme.NavDrawer.close();
          Tawk_API.toggle();
        }
      });
    },

    /**
     * Initialize rewards
     */
    _initRewards: function() {
      var $rewardsLink = $('a[href^="#rewardslink"]');

      $rewardsLink.on("click",function(e){
        e.preventDefault();

        if (typeof showSwellModal !== 'undefined') {
          theme.NavDrawer.close();
          showSwellModal();
        }
      });
    },

    /**
     * Add site nav more menu
     */
    _addSiteNavMoreMenu: function() {
      var $siteNavMoreLinks = $(selectors.siteNavLinks).slice(-3);

      // Create menu items
      $($siteNavMoreLinks).parent().addClass('site-nav__item--more__root');
      $(selectors.siteNav).append('<li class="site-nav__item site-nav__item--more"></li>');
      $(selectors.siteNavItemMore).append('<a class="site-nav__link site-nav__link--more site-nav__link--last" href="#">' + selectors.siteNavLinkMoreText + '</a>');
      $(selectors.siteNavLinkMore).append('<ul class="site-nav__dropdown--more"></ul>');

      // Add list items
      $($siteNavMoreLinks).each(function() {
        $(selectors.siteNavDropdownMore).append('<li class="site-nav__item"><a class="site-nav__link site-nav__link--more" href="' + this.href + '">' + this.text + '</a></li>');
      });
    },

    /**
     * Add site nav events
     */
    _addSiteNavEvents: function() {
      // Site nav hover event
      $(selectors.siteNavLinks).hover(
        function () {
          $(this).parent().prev('li').find('a').addClass(selectors.siteNavLinkBefore);
        },
        function () {
          $(this).parent().prev('li').find('a').removeClass(selectors.siteNavLinkBefore);
        }
      );

      // More link hover event
      var $siteNavLastLink = $(selectors.siteNavLinkMoreRoot).first().prev().find('a');
      $(selectors.siteNavLinkMore).hover(
        function () {
          $(this).find('ul').show();
          $($siteNavLastLink).addClass(selectors.siteNavLinkBefore);
        },
        function () {
          $(this).find('ul').hide();
          $($siteNavLastLink).removeClass(selectors.siteNavLinkBefore);
        }
      );
    }
  });

  return Header;
})();

/**
 * Footer section
 * ------------------------------------------------------------------------------
 * Controls Footer section functionality.
 *
 * @namespace FooterSection
 */

theme.FooterSection = (function () {
  /**
   * Footer section constructor. Runs on page load as well as Theme Editor
   * `section:load` events.
   */
  function Footer() {
    this._init();
  }

  Footer.prototype = $.extend({}, Footer.prototype, {

    /**
     * Initialize
     */
    _init: function() {
      this._initAccordionMenu();
    },

    /**
     * Initialize accordion menu
     */
    _initAccordionMenu: function() {
      new window.Accordions({
        $accordionToggle: $('footer .accordion-toggle'),
        disableBreakpoint: 'medium_up',
        resetBreakpoint: 'medium_up'
      });
    }
  });

  return Footer;
})();

/**
 * Maps module
 * ------------------------------------------------------------------------------
 * Controls maps functionality.
 *
 * @namespace Maps
 */

theme.Maps = (function () {
  var config = {
    zoom: 14,
    styles: [{featureType:'water',elementType:'geometry',stylers:[{color:'#cacaca'},{lightness:17}]},{featureType:'landscape',elementType:'geometry',stylers:[{color:'#e1e1e1'},{lightness:20}]},{featureType:'road.highway',elementType:'geometry.fill',stylers:[{color:'#ffffff'},{lightness:17}]},{featureType:'road.highway',elementType:'geometry.stroke',stylers:[{color:'#ffffff'},{lightness:29},{weight:0.2}]},{featureType:'road.arterial',elementType:'geometry',stylers:[{color:'#ffffff'},{lightness:18}]},{featureType:'road.local',elementType:'geometry',stylers:[{color:'#ffffff'},{lightness:16}]},{featureType:'poi',elementType:'geometry',stylers:[{color:'#e1e1e1'},{lightness:21}]},{featureType:'poi.park',elementType:'geometry',stylers:[{color:'#bbbbbb'},{lightness:21}]},{elementType:'labels.text.stroke',stylers:[{visibility:'on'},{color:'#ffffff'},{lightness:16}]},{elementType:'labels.text.fill',stylers:[{saturation:36},{color:'#333333'},{lightness:40}]},{elementType:'labels.icon',stylers:[{visibility:'off'}]},{featureType:'transit',elementType:'geometry',stylers:[{color:'#f2f2f2'},{lightness:19}]},{featureType:'administrative',elementType:'geometry.fill',stylers:[{color:'#fefefe'},{lightness:20}]},{featureType:'administrative',elementType:'geometry.stroke',stylers:[{color:'#fefefe'},{lightness:17},{weight:1.2}]}] // eslint-disable-line key-spacing, comma-spacing
  };
  var apiStatus = null;
  var mapsToLoad = [];
  var key = theme.mapKey ? theme.mapKey : '';


  /**
   * Map section constructor. Runs on page load as well as Theme Editor
   * `section:load` events.
   */
  function Map(container) {
    this.$container = $(container);

    if (apiStatus === 'loaded') {
      this.createMap();
    } else {
      mapsToLoad.push(this);

      if (apiStatus !== 'loading') {
        apiStatus = 'loading';
        if (typeof window.google === 'undefined') {
          $.getScript('https://maps.googleapis.com/maps/api/js?key=' + key)
            .then(function () {
              apiStatus = 'loaded';
              initAllMaps();
            });
        }
      }
    }
  }

  /**
   * Init all maps
   */
  function initAllMaps() {
    // API has loaded, load all Map instances in queue
    $.each(mapsToLoad, function (index, instance) {
      instance.createMap();
    });
  }

  /**
   * Geo locate
   * @param $map
   * @returns {*}
   */
  function geolocate($map) {
    var deferred = $.Deferred();
    var geocoder = new google.maps.Geocoder();
    var address = $map.data('address-setting');

    geocoder.geocode({address: address}, function (results, status) {
      if (status !== google.maps.GeocoderStatus.OK) {
        deferred.reject(status);
      }

      deferred.resolve(results);
    });

    return deferred;
  }

  Map.prototype = $.extend({}, Map.prototype, {
    /**
     * Create map
     * @returns {*}
     */
    createMap: function () {
      var $map = this.$container.find('.map-section__container');

      return geolocate($map)
        .then(function (results) {
          var mapOptions = {
            zoom: config.zoom,
            styles: config.styles,
            center: results[0].geometry.location,
            disableDefaultUI: true
          };

          var map = this.map = new google.maps.Map($map[0], mapOptions);
          var center = this.center = map.getCenter();
          var markerColor = $map.data('marker-color');

          var markerIcon = {
            path: 'M57.7,0C25.8,0,0,25.8,0,57.7C0,89.5,50,170,57.7,170s57.7-80.5,57.7-112.3C115.3,25.8,89.5,0,57.7,0z M57.7,85 c-14.9,0-27-12.1-27-27c0-14.9,12.1-27,27-27c14.9,0,27,12.1,27,27C84.7,72.9,72.6,85,57.7,85z',
            fillColor: markerColor,
            fillOpacity: 0.9,
            scale: 0.2,
            strokeWeight: 0
          };

          //eslint-disable-next-line no-unused-vars
          var marker = new google.maps.Marker({
            map: map,
            position: map.getCenter(),
            icon: markerIcon
          });

          google.maps.event.addDomListener(window, 'resize', $.debounce(250, function () {
            google.maps.event.trigger(map, 'resize');
            map.setCenter(center);
          }));
        }.bind(this))
        .fail(function () {
          var errorMessage;

          switch (status) {
            case 'ZERO_RESULTS':
              errorMessage = theme.strings.addressNoResults;
              break;
            case 'OVER_QUERY_LIMIT':
              errorMessage = theme.strings.addressQueryLimit;
              break;
            default:
              errorMessage = theme.strings.addressError;
              break;
          }

          $map
            .parent()
            .addClass('page-width map-section--load-error')
            .html('<div class="errors text-center">' + errorMessage + '</div>');
        });
    },

    /**
     * Unload
     */
    onUnload: function () {
      google.maps.event.clearListeners(this.map, 'resize');
    }
  });

  return Map;
})();

// Global function called by Google on auth errors.
// Show an auto error message on all map instances.
// eslint-disable-next-line camelcase, no-unused-vars
function gm_authFailure() {
  $('.map-section').addClass('map-section--load-error');
  $('.map-section__container').remove();
  $('.map-section__link').remove();
  $('.map-section__overlay').after('<div class="errors text-center">' + theme.strings.authError + '</div>');
}
/**
 * Slideshow section
 * ------------------------------------------------------------------------------
 * Controls slideshow section functionality.
 *
 * @namespace Slideshow
 */

theme.Slideshow = (function () {
  /**
   * Slideshow section constructor. Runs on page load as well as Theme Editor
   * `section:load` events.
   */
  function Slideshow() {
    this.slideshow = new theme.Hero();
  }

  Slideshow.prototype = $.extend({}, Slideshow.prototype, {
    /**
     * Unload
     */
    onUnload: function () {
      this.slideshow.destroy();
    },

    /**
     * Select
     */
    onSelect: function () {
      this.slideshow.pause();
    },

    /**
     * Deselect
     */
    onDeselect: function () {
      this.slideshow.play();
    },

    /**
     * Block select
     * @param evt
     */
    onBlockSelect: function (evt) {
      var $slide = $('.hero__slide--' + evt.detail.blockId + ':not(.slick-cloned)');
      var slideIndex = $slide.data('slick-index');
      this.slideshow.pause();
      this.slideshow.goToSlide(slideIndex);
    },

    /**
     * Block deselect
     */
    onBlockDeselect: function () {
      this.slideshow.play();
    }
  });

  return Slideshow;
})();
/**
 * Quotes section
 * ------------------------------------------------------------------------------
 * Controls header section functionality.
 *
 * @namespace Quotes
 */

theme.Quotes = (function () {
  /**
   * Quotes section constructor. Runs on page load as well as Theme Editor
   * `section:load` events.
   */
  function Quotes(container) {
    this.$container = $(container).on('init', this._a11y.bind(this));

    this.$container.slick({
      accessibility: true,
      arrows: false,
      dots: true,
      draggable: true,
      autoplay: false
    });
  }

  Quotes.prototype = $.extend({}, Quotes.prototype, {
    /**
     * Ally fixes
     * @param event
     * @param obj
     * @private
     */
    _a11y: function (event, obj) {
      var $list = obj.$list;
      var $wrapper = this.$container.parent();

      // Remove default Slick aria-live attr until slider is focused
      $list.removeAttr('aria-live');

      // When an element in the slider is focused set aria-live
      $wrapper.on('focusin', function (evt) {
        if ($wrapper.has(evt.target).length) {
          $list.attr('aria-live', 'polite');
        }
      });

      // Remove aria-live
      $wrapper.on('focusout', function (evt) {
        if ($wrapper.has(evt.target).length) {
          $list.removeAttr('aria-live');
        }
      });
    },

    /**
     * Goto slide
     * @param slideIndex
     * @private
     */
    _goToSlide: function (slideIndex) {
      this.$container.slick('slickGoTo', slideIndex);
    },

    /**
     * Unload
     */
    onUnload: function () {
      delete this.$container;
    },

    /**
     * Block select
     * @param evt
     */
    onBlockSelect: function (evt) {
      // Ignore the cloned version
      var $slide = $('.quote__slide-wrapper--' + evt.detail.blockId + ':not(.slick-cloned)');
      var slideIndex = $slide.data('slick-index');

      // Go to selected slide, pause autoplay
      this._goToSlide(slideIndex);
    }
  });

  return Quotes;
})();
/**
 * Quotes section
 * ------------------------------------------------------------------------------
 * Controls header section functionality.
 *
 * @namespace Quotes
 */

theme.InstagramFeed = (function () {
  /**
   * InstagramFeed section constructor. Runs on page load as well as Theme Editor
   * `section:load` events.
   */
  function InstagramFeed(container) {
    this.$container = $(container);
    this.settings = {
      accessTokenUrl: this.$container.data('access-token-url'),
    };

    $.ajax({
      url: this.settings.accessTokenUrl,
      dataType: 'json'

    }).done(function(data) {
      var tokenData = JSON.stringify(data);
      var tokenJSON = $.parseJSON(tokenData);

      // Instantiate feed
      this.feed = new Instafeed({
        get: 'user',
        target: this.$container.attr('id'),
        accessToken: tokenJSON.Token,
        resolution: 'standard_resolution',
        template: '<div><a href="{{link}}"><img src="{{image}}" /></a></div>',
        limit: 12,

        after: function () {
          var breakpointMedium = slate.MediaQuery.medium;
          var breakpointSmall = slate.MediaQuery.small;

          $('.instagram-slider').slick({
            infinite: false,
            slidesPerRow: 4,
            rows: 1,
            responsive: [
              {
                breakpoint: breakpointMedium,
                settings: {
                  slidesPerRow: 3,
                  rows: 1
                }
              },
              {
                breakpoint: breakpointSmall,
                settings: {
                  slidesPerRow: 2,
                  rows: 2
                }
              }
            ]
          });
        }
      });

      this.feed.run();
    }.bind(this));
  }

  InstagramFeed.prototype = $.extend({}, InstagramFeed.prototype, {
    /**
     * Unload sections
     */
    onSectionUnload: function () {
      this.feed.destroy();
    },
  });

  return InstagramFeed;
})();
/**
 * Collection Templates
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Collection template.
 *
 * @namespace Collection
 */

theme.Collection = (function () {
  var selectors = {
    filterMenu: '.filter-menu'
  };

  /**
   * Collections template
   * @constructor
   */
  function Collection(container) {
    this.$container = $(container);
    this.$filterMenu = $(selectors.filterMenu);
    this.totalTagCount = this.$filterMenu.data('total-tag-count');
    this.init();
  }

  Collection.prototype = $.extend({}, Collection.prototype, {

    /**
     * Initialize
     */
    init: function() {
      this.pager = new theme.Pager();
      this.filters = new theme.Filters();
    },

    /**
     * Initialize filter
     */
    initFilter: function() {
      if(this.totalTagCount > 0) {
        this.filters = new theme.Filters();
      } else {
        this.setFilterContent();
      }
    },

    /**
     * Get filter data
     */
    setFilterContent: function() {
      var params = {
        url: '/collections/all',
        dataType: 'html',
        success: $.proxy(function (data) {
          this.setFilterContentSuccess(data);
        }, this)
      };

      $.ajax(params);
    },

    /**
     * Set filter content success handler
     * @param data
     */
    setFilterContentSuccess: function(data) {
      // Update filter content
      var filter_Html = $(data).find('.side-filter-menu').html();
      $('.side-filter-menu').html(filter_Html);

      // Create new filter
      this.filters = new theme.Filters();
    }
  });

  return Collection;
})();
/**
 * List Collections Templates
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the List Collections template.
 *
 * @namespace Collection
 */

theme.ListCollections = (function () {
  /**
   * ListCollections template
   * @constructor
   */
  function ListCollections(container) {
    this.$container = $(container);
    this.init();
  }

  ListCollections.prototype = $.extend({}, ListCollections.prototype, {

    /**
     * Initialize
     */
    init: function () {
    }
  });

  return ListCollections;
})();
/**
 * Search Templates
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Search template.
 *
 * @namespace Search
 */

theme.Search = (function () {
  var selectors = {
    filterMenu: '.filter-menu'
  };

  /**
   * Search template
   * @constructor
   */
  function Search(container) {
    this.$container = $(container);
    this.$filterMenu = $(selectors.filterMenu);
    this.totalTagCount = this.$filterMenu.data('total-tag-count');
    this.init();
  }

  Search.prototype = $.extend({}, Search.prototype, {

    /**
     * Initialize
     */
    init: function() {
      this.pager = new theme.Pager();
      this.filters = new theme.Filters();
    },

    /**
     * Initialize filter
     */
    initFilter: function() {
      if(this.totalTagCount > 0) {
        this.filters = new theme.Filters();
      } else {
        this.setFilterContent();
      }
    },

    /**
     * Get filter data
     */
    setFilterContent: function() {
      var params = {
        url: '/collections/all',
        dataType: 'html',
        success: $.proxy(function (data) {
          this.setFilterContentSuccess(data);
        }, this)
      };

      $.ajax(params);
    },

    /**
     * Set filter content success handler
     * @param data
     */
    setFilterContentSuccess: function(data) {
      // Update filter content
      var filter_Html = $(data).find('.side-filter-menu').html();
      $('.side-filter-menu').html(filter_Html);

      // Create new filter
      this.filters = new theme.Filters();
    }
  });

  return Search;
})();
/**
 * Article Templates
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Article template.
 *
 * @namespace Article
 */

theme.Article = (function () {
  /**
   * Article template
   * @constructor
   */
  function Article(container) {
    this.$container = $(container);
    this.init();
  }

  Article.prototype = $.extend({}, Article.prototype, {

    /**
     * Initialize
     */
    init: function () {
      this._checkImages();
    },

    /**
     * Process article images
     * @private
     */
    _checkImages: function() {
      var $indentedRteImages = $('.rte--indented-images');
      if (!$indentedRteImages.length) {
        return;
      }

      $indentedRteImages.find('img').each(function (i, el) {
        var $el = $(el);
        var attr = $el.attr('style');

        // Check if undefined or float: none
        if (!attr || attr === 'float: none;') {
          // Add class to parent paragraph tag if image is wider than container
          if ($el.width() >= $indentedRteImages.width()) {
            $el.parent('p').addClass('rte__image-indent');
          }
        }
      });
    }
  });

  return Article;
})();
/**
 * Page Templates
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Page template.
 *
 * @namespace Page
 */

theme.Page = (function () {
  /**
   * Page template
   * @constructor
   */
  function Page(container) {
    this.$container = $(container);
    this.init();
  }

  Page.prototype = $.extend({}, Page.prototype, {

    /**
     * Initialize
     */
    init: function () {
    }
  });

  return Page;
})();
/**
 * Password Templates
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Password template.
 *
 * @namespace Password
 */

theme.Password = (function () {
  /**
   * Password template
   * @constructor
   */
  function Password(container) {
    this.$container = $(container);
    this.init();
  }

  Password.prototype = $.extend({}, Password.prototype, {

    /**
     * Initialize
     */
    init: function () {
      this._initPasswordsModal();
    },

    /**
     * Initialize passwords modal
     * @private
     */
    _initPasswordsModal: function() {
      var $passwordsModal;
      var $loginModal = $('#LoginModal');
      if (!$loginModal.length) {
        return;
      }

      // Initialize modal
      $passwordsModal = new window.Modals('LoginModal', 'login-modal', {
        focusOnOpen: '#Password'
      });

      // Open modal if errors exist
      if ($loginModal.find('.errors').length) {
        $passwordsModal.open();
      }
    }
  });

  return Password;
})();
/**
 * Cart Templates
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Cart template.
 *
 * @namespace Cart
 */

theme.Cart = (function () {
  var selectors = {
    cartNote: '#CartSpecialInstructions',
    cartQtyInput: '.cart__quantity',
    cartNoCookiesClass: 'cart--no-cookies'
  };

  /**
   * Cart template
   * @constructor
   */
  function Cart(container) {
    this.$container = $(container);
    theme.cartObject = JSON.parse($('#CartJson').html());
    this.init();
  }

  Cart.prototype = $.extend({}, Cart.prototype, {

    /**
     * Initialize
     */
    init: function () {
      this._initQtySelector();
      this._initCartNote();

      if (!this._cookiesEnabled()) {
        this.$container.addClass(selectors.cartNoCookiesClass);
      }
    },

    /**
     * Initialize quantity selector
     * @private
     */
    _initQtySelector: function () {
      $(selectors.cartQtyInput).each(function (i, el) {
        // eslint-disable-next-line no-new
        new QtySelector($(el));
      });
    },

    /**
     * Initialize cart notes
     * @private
     */
    _initCartNote: function () {
      if (!$(selectors.cartNote).length) {
        return;
      }

      var $el = $(selectors.cartNote);
      var noteText;
      var params;
      var noteOffset = $el[0].offsetHeight - $el[0].clientHeight;

      // Auto grow the cart note if text fills it up
      $el.on('keyup input', function () {
        $(this).css('height', 'auto').css('height', $el[0].scrollHeight + noteOffset);
      });

      // Save the cart note via ajax. A safeguard in case
      // a user decides to leave the page before clicking 'Update Cart'
      $el.on('change', $.proxy(function () {
        noteText = $el.val();
        params = {
          type: 'POST',
          url: '/cart/update.js',
          data: 'note=' + this._attributeToString(noteText),
          dataType: 'json'
        };
        $.ajax(params);
      }, this));
    },

    /**
     * Return attribute string
     * @param attr
     * @returns {string|*}
     * @private
     */
    _attributeToString: function (attr) {
      if ((typeof attr) !== 'string') {
        attr = String(attr);
        if (attr === 'undefined') {
          attr = '';
        }
      }
      return $.trim(attr);
    },

    /**
     * Check if cookies are enabled
     * @returns {boolean}
     * @private
     */
    _cookiesEnabled: function () {
      var cookieEnabled = navigator.cookieEnabled;

      if (!cookieEnabled) {
        document.cookie = 'testcookie';
        cookieEnabled = (document.cookie.indexOf('testcookie') !== -1);
      }
      return cookieEnabled;
    }
  });

  return Cart;
})();
/**
 * Product Templates
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Product template.
 *
 * @namespace Product
 */

theme.Product = (function () {
  var defaults = {
    smallBreakpoint: slate.MediaQuery.extra_small,
    mediumBreakpoint: slate.MediaQuery.medium,
    productThumbIndex: 0,
    productThumbMax: 0,
    productZoom: true,
    ajaxCart: false,
    stockSetting: false
  };

  var selectors = {
    originalSelectorId: '#ProductSelect',
    modal: 'ProductModal',
    productZoomImage: '#ProductZoomImg',
    addToCart: '#AddToCart',
    productPrice: '#ProductPrice',
    comparePrice: '#ComparePrice',
    addToCartText: '#AddToCartText',
    SKU: '.variant-sku',
    productFeaturedImage: '#ProductPhotoImg',
    productImageWrap: '#ProductPhotoLink',
    productThumbAllImages: '.product-single__thumbnail',
    productThumbImages: '.product-single__thumbnail',
    productThumbs: '#ProductThumbs',
    productRelatedProducts: '#RelatedProducts',
    saleTag: '#ProductSaleTag',
    productStock: '#ProductStock',
    singleOptionSelector: '.single-option-selector'
  };

  /**
   * Product template
   * @param options
   * @constructor
   */
  function Product(container) {
    if(!$(container).length &&
      !$(container).data('quickview')) {
      return;
    }

    this.$container = $(container);
    this.selectors = selectors;
    this.settings = $.extend({}, defaults, {
      productZoom: this.$container.data('zoom'),
      ajaxCart: this.$container.data('ajax'),
      quickView: this.$container.data('quickview'),
      stockSetting: this.$container.data('stock'),
      enableHistoryState: this.$container.data('enable-history-state') || false,
      namespace: '.product',
      imageSize: theme.Images.imageSize($(this.selectors.productFeaturedImage).attr('src'))
    });

    // Stop parsing if we don't have the product json script tag
    if (!$('#ProductJson').html()) {
      return;
    }

    this.productSingleObject = JSON.parse($('#ProductJson').html());
    this.addVariantInfo();
    this.init();
  }

  Product.prototype = $.extend({}, Product.prototype, {

    /**
     * Initialize
     */
    init: function () {
      this._stringOverrides();
      this._initVariants();
      this._productZoomImage();
      this._productModal();
      this._productThumbnailSlider();
      this._productThumbSwitch();
      this._productRelatedSlider();

      if (this.settings.ajaxCart) {
        theme.AjaxCart = new window.AjaxCart($('#AddToCartForm'));
      }

      // Pre-loading product images to avoid a lag when a thumbnail is clicked, or
      // when a variant is selected that has a variant image.
      theme.Images.preload(this.productSingleObject.images, this.settings.imageSize);
    },

    /**
     * Add variant info from section variant JSON
     */
    addVariantInfo: function () {
      if (!this.productSingleObject || !this.settings.stockSetting) {
        return;
      }

      var variantInfo = JSON.parse($('#VariantJson').html());

      for (var i = 0; i < variantInfo.length; i++) {
        $.extend(this.productSingleObject.variants[i], variantInfo[i]);
      }
    },

    /**
     * Override theme product strings
     */
    _stringOverrides: function () {
      window.productStrings = window.productStrings || {};
      $.extend(theme.strings, window.productStrings);
    },

    /**
     * Handles change events from the variant inputs
     */
    _initVariants: function () {
      var options = {
        $container: this.$container,
        enableHistoryState: this.settings.enableHistoryState,
        product: this.productSingleObject,
        singleOptionSelector: this.selectors.singleOptionSelector,
        originalSelectorId: this.selectors.originalSelectorId
      };

      // eslint-disable-next-line no-new
      this.variants = new slate.Variants(options);

      this.$container.on('variantChange' + this.settings.namespace, this._updateAddToCartBtn.bind(this));
      this.$container.on('variantPriceChange' + this.settings.namespace, this._updatePrice.bind(this));
      this.$container.on('variantSKUChange' + this.settings.namespace, this._updateSKU.bind(this));
      this.$container.on('variantImageChange' + this.settings.namespace, this._updateImages.bind(this));
    },

    /**
     * Updates the DOM state of the add to cart button
     *
     * @param {boolean} enabeled - Decides whether cart is enabled or disabled
     * @param {string} text - Updates the text notification content of the cart
     */
    _updateAddToCartBtn: function (evt) {
      var variant = evt.variant;

      var cache = {
        $stock: $(this.selectors.productStock),
        $addToCart: $(this.selectors.addToCart),
        $addToCartText: $(this.selectors.addToCartText)
      };

      if (variant) {
        // Select a valid variant if available
        if (variant.available) {
          // We have a valid product variant, so enable the submit button
          cache.$addToCart.removeClass('btn--sold-out').prop('disabled', false);
          cache.$addToCartText.html(theme.strings.addToCart);
          // Show how many items are left, if below 10
          if (this.settings.stockSetting) {
            if (variant.inventory_management) {
              if (variant.inventory_quantity < 10 && variant.inventory_quantity > 0) {
                cache.$stock
                  .html(theme.strings.stockAvailable.replace('1', variant.inventory_quantity))
                  .removeClass('hide');
              } else if (variant.inventory_quantity <= 0 && variant.incoming) {
                cache.$stock
                  .html(theme.strings.willNotShipUntil.replace('[date]', variant.next_incoming_date))
                  .removeClass('hide');
              } else {
                cache.$stock.addClass('hide');
              }
            } else {
              cache.$stock.addClass('hide');
            }
          }
        } else {
          // Variant is sold out, disable the submit button
          cache.$addToCart.prop('disabled', true).addClass('btn--sold-out');
          cache.$addToCartText.html(theme.strings.soldOut);
          if (this.settings.stockSetting) {
            if (variant.incoming) {
              cache.$stock
                .html(theme.strings.willBeInStockAfter.replace('[date]', variant.next_incoming_date))
                .removeClass('hide');
            } else {
              cache.$stock.addClass('hide');
            }
          }
        }
      } else {
        cache.$addToCart.prop('disabled', true).removeClass('btn--sold-out');
        cache.$addToCartText.html(theme.strings.unavailable);
        if (this.settings.stockSetting) {
          cache.$stock.addClass('hide');
        }
      }
    },

    /**
     * Updates the DOM with specified prices
     *
     * @param {string} productPrice - The current price of the product
     * @param {string} comparePrice - The original price of the product
     */
    _updatePrice: function (evt) {
      var variant = evt.variant;

      if (variant) {
        $(this.selectors.productPrice).html(theme.Currency.formatMoney(variant.price, theme.moneyFormat));

        // Update and show the product's compare price if necessary
        if (variant.compare_at_price > variant.price) {
          $(this.selectors.comparePrice)
            .html(theme.Currency.formatMoney(variant.compare_at_price, theme.moneyFormat))
            .removeClass('hide');
          $(this.selectors.saleTag).removeClass('hide');
        } else {
          $(this.selectors.comparePrice).addClass('hide');
          $(this.selectors.saleTag).addClass('hide');
        }
      } else {
        $(this.selectors.comparePrice).addClass('hide');
      }
    },

    /**
     * Update SKU
     * @param evt
     * @private
     */
    _updateSKU: function (evt) {
      var variant = evt.variant;

      if (variant) {
        $(this.selectors.SKU).html(variant.sku);
      }
    },

    /**
     * Updates the DOM with the specified image URL
     *
     * @param {string} src - Image src URL
     */
    _updateImages: function (evt) {
      var variant = evt.variant;

      if (variant && variant.featured_image) {
        var sizedImgUrl = theme.Images.getSizedImageUrl(variant.featured_image.src, this.settings.imageSize);
        var largeImgUrl = theme.Images.getSizedImageUrl(variant.featured_image.src, '1024x1024');
        this.switchProductImage(sizedImgUrl, largeImgUrl);
        this.setActiveThumbnail();
      }
    },

    /**
     * Switch product image
     * @param image
     * @param largeImage
     */
    switchProductImage: function (image, largeImage) {
      $(this.selectors.productFeaturedImage).attr('src', image);
      $(this.selectors.productImageWrap).attr('href', largeImage);

      // Product zoom
      this._productZoomImage();
    },

    /**
     * Set active thumbnail
     * @param $el
     */
    setActiveThumbnail: function ($el) {
      var $thumbnails = $(this.selectors.productThumbs);

      // If there is no element passed, find it by the current product image
      if (typeof $el === 'undefined') {
        var src = $(this.selectors.productFeaturedImage).attr('src');
        $el = $('.product-single__thumbnail[href="' + src + '"]');
      }

      // Set active thumbnail class
      $thumbnails.find('.product-single__thumbnail-item').removeClass('is-active');
      $el.parent().addClass('is-active');

      // If there is a slick carousel, get the slide index, and position it into view with animation.
      if ($thumbnails.hasClass('slick-initialized')) {
        // eslint-disable-next-line shopify/jquery-dollar-sign-reference
        var currentActiveSlideIndex = $thumbnails.slick('slickCurrentSlide');
        var newActiveSlideIndex = $el.parent().attr('data-slick-index');
        if (currentActiveSlideIndex !== newActiveSlideIndex) {
          $thumbnails.slick('slickGoTo', newActiveSlideIndex, false);
        }
      }
    },

    /**
     * Zoom product image
     * @private
     */
    _productZoomImage: function () {
      if (!$(this.selectors.productFeaturedImage).length ||
        !this.settings.productZoom) {
        return;
      }

      // Load zoom plugin
      var zoom_large = $(this.selectors.productImageWrap).attr('href');
      $(this.selectors.productFeaturedImage).trigger('zoom.destroy');
      $(this.selectors.productFeaturedImage).css('display', 'block').parent().zoom({url: zoom_large});
    },

    /**
     * Product Modal window
     * @private
     */
    _productModal: function() {
      if (!$(this.selectors.productFeaturedImage).length) {
        return;
      }

      var self = this;

      // Populate product modal
      $(this.selectors.productImageWrap).on('click' + this.settings.namespace, function (evt) {
        evt.preventDefault();
        // Empty src before loadig new image to avoid awkward image swap
        $(self.selectors.productZoomImage)
          .attr('src', '')
          .attr('src', $(this).attr('href'));
      });

      this.ProductModal = new window.Modals(this.selectors.modal, 'product-modal');

      // Close modal if clicked, but not if the image is clicked
      this.ProductModal.$modal.on('click' + this.settings.namespace, function (evt) {
        if (evt.target.nodeName !== 'IMG') {
          self.ProductModal.close();
        }
      });
    },

    /**
     * Switch product thumbnail
     * @private
     */
    _productThumbSwitch: function () {
      if (!$(this.selectors.productThumbs).length) {
        return;
      }

      var self = this;

      $(this.selectors.productThumbImages).on('click' + this.settings.namespace, function (evt) {
        evt.preventDefault();
        var $el = $(this);
        var sizedImageUrl = $el.attr('href');
        var largeImageUrl = $el.attr('data-zoom');
        self.setActiveThumbnail($el);
        self.switchProductImage(sizedImageUrl, largeImageUrl);
      });
    },

    /**
     * Thumbnail slider
     * @private
     */
    _productThumbnailSlider: function () {
      var $productThumbWrapper = $(this.selectors.productThumbs);
      if (!$productThumbWrapper.length) {
        return;
      }

      $productThumbWrapper.on('init' + this.settings.namespace, this._productSwipeInit.bind(this));

      var nextArrow;
      var prevArrow;
      var sliderArrows = window.sliderArrows || false;

      // sliderArrows is an object defined in product.liquid to set custom
      // SVG arrow icons.
      if (sliderArrows) {
        nextArrow = '<button type="button" class="slick-next">' + sliderArrows.right + '</button>';
        prevArrow = '<button type="button" class="slick-prev">' + sliderArrows.left + '<</button>';
      }

      $productThumbWrapper.slick({
        infinite: false,
        vertical: true,
        verticalSwiping: true,
        slidesToShow: 5,
        slidesToScroll: 5,
        arrows: true,
        nextArrow: nextArrow,
        prevArrow: prevArrow,
        responsive: [
          {
            breakpoint: this.settings.mediumBreakpoint,
            settings: {
              vertical: false,
              verticalSwiping: false,
            }
          }
        ]
      }).on('breakpoint', function(evt){
        this._productThumbSwitch();
      }.bind(this));

      // Show highlighted thumbnail by repositioning slider
      $productThumbWrapper.slick('slickGoTo', $productThumbWrapper.find('.is-active').attr('data-slick-index'), true);
    },

    /**
     * Add related products slider
     * @private
     */
    _productRelatedSlider: function () {
      var $productRelatedWrapper = $(this.selectors.productRelatedProducts);
      if (!$productRelatedWrapper.length) {
        return;
      }

      $productRelatedWrapper.slick({
        infinite: false,
        slidesPerRow: 4,
        rows: 1,
        responsive: [
          {
            breakpoint: this.settings.smallBreakpoint,
            settings: {
              slidesPerRow: 2,
              rows: 1
            }
          },
          {
            breakpoint: this.settings.mediumBreakpoint,
            settings: {
              slidesPerRow: 4,
              rows: 1
            }
          }
        ]
      });
    },

    /**
     * Init roduct swipe
     * @param evt
     * @param obj
     * @private
     */
    _productSwipeInit: function (evt, obj) {
      // Slider is initialized. Setup custom swipe events
      this.settings.productThumbIndex = obj.currentSlide;
      this.settings.productThumbMax = obj.slideCount - 1; // we need the 0-based index

      $(this.selectors.productFeaturedImage).on('swipeleft swiperight', function (event) {
        if (event.type === 'swipeleft') {
          this._goToNextThumbnail();
        }

        if (event.type === 'swiperight') {
          this._goToPrevThumbnail();
        }

        // Trigger click on newly requested thumbnail
        $('.product-single__thumbnail-item[data-slick-index="' + this.settings.productThumbIndex + '"]').find('.product-single__thumbnail').trigger('click');
      });
    },

    /**
     * Next thumbnail
     * @private
     */
    _goToNextThumbnail: function () {
      this.settings.productThumbIndex++;

      if (this.settings.productThumbIndex > this.settings.productThumbMax) {
        this.settings.productThumbIndex = 0;
      }

      $(this.selectors.productThumbs).slick('slickGoTo', this.settings.productThumbIndex, true);
    },

    /**
     * Previous thumbnail
     * @private
     */
    _goToPrevThumbnail: function () {
      this.settings.productThumbIndex--;

      if (this.settings.productThumbIndex < 0) {
        this.settings.productThumbIndex = this.settings.productThumbMax;
      }

      $(this.selectors.productThumbs).slick('slickGoTo', this.settings.productThumbIndex, true);
    },

    /**
     * Init quantity
     * @private
     */
    _initQtySelector: function () {
      this.$container.find('.product-form__quantity').each(function (i, el) {
        // eslint-disable-next-line no-new
        new QtySelector($(el));
      });
    }
  });

  return Product;
})();


/*================ TEMPLATES ================*/
/**
 * Customers Templates
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Customers template.
 *
 * @namespace Customers
 */

theme.Customers = (function () {
  var selectors = {
    template: '[data-template="customers"]',
    container: '#Customers'
  };

  /**
   * Customers template
   * @constructor
   */
  function Customers() {
    if(!$(selectors.template).length) {
      return;
    }

    this.$container = $(selectors.container);
    this.init();
  }

  Customers.prototype = $.extend({}, Customers.prototype, {

    /**
     * Initialize
     */
    init: function () {
      this._checkUrlHash();
      this._initEventListeners();
      this._resetPasswordSuccess();
      this._customerAddressForm();
    },

    /**
     * Initialize event listeners
     * @private
     */
    _initEventListeners: function() {
      // Show reset password form
      $('#RecoverPassword').on('click', function (evt) {
        evt.preventDefault();
        this._toggleRecoverPasswordForm();
      }.bind(this));

      // Hide reset password form
      $('#HideRecoverPasswordLink').on('click', function (evt) {
        evt.preventDefault();
        this._toggleRecoverPasswordForm();
      }.bind(this));
    },

    /**
     * Show/hide customer address forms
     * @private
     */
    _customerAddressForm: function() {
      var $newAddressForm = $('#AddressNewForm');

      if (!$newAddressForm.length) {
        return;
      }

      // Initialize observers on address selectors, defined in shopify_common.js
      if (Shopify) {
        // eslint-disable-next-line no-new
        new Shopify.CountryProvinceSelector('AddressCountryNew', 'AddressProvinceNew', {
          hideElement: 'AddressProvinceContainerNew'
        });
      }

      // Initialize each edit form's country/province selector
      $('.address-country-option').each(function () {
        var formId = $(this).data('form-id');
        var countrySelector = 'AddressCountry_' + formId;
        var provinceSelector = 'AddressProvince_' + formId;
        var containerSelector = 'AddressProvinceContainer_' + formId;

        // eslint-disable-next-line no-new
        new Shopify.CountryProvinceSelector(countrySelector, provinceSelector, {
          hideElement: containerSelector
        });
      });

      // Toggle new/edit address forms
      $('.address-new-toggle').on('click', function () {
        $newAddressForm.toggleClass('hide');
      });

      $('.address-edit-toggle').on('click', function () {
        var formId = $(this).data('form-id');
        $('#EditAddress_' + formId).toggleClass('hide');
      });

      $('.address-delete').on('click', function () {
        var $el = $(this);
        var formId = $el.data('form-id');
        var confirmMessage = $el.data('confirm-message');

        // eslint-disable-next-line no-alert
        if (confirm(confirmMessage || 'Are you sure you wish to delete this address?')) {
          Shopify.postLink('/account/addresses/' + formId, {parameters: {_method: 'delete'}});
        }
      });
    },

    /**
     * Show/Hide recover password form
     * @private
     */
    _toggleRecoverPasswordForm: function() {
      $('#RecoverPasswordForm').toggleClass('hide');
      $('#CustomerLoginForm').toggleClass('hide');
    },

    /**
     * Show reset password success message
     * @private
     */
    _resetPasswordSuccess: function() {
      // check if reset password form was successfully submited
      if (!$('.reset-password-success').length) {
        return;
      }

      // show success message
      $('#ResetSuccess').removeClass('hide');
    },

    /**
     * Check URL for reset password hash
     * @private
     */
    _checkUrlHash: function() {
      var hash = window.location.hash;

      // Allow deep linking to recover password form
      if (hash === '#recover') {
        this._toggleRecoverPasswordForm();
      }
    }
  });

  return Customers;
})();

$(document).ready(function() {
  // Register sections
  var sections = new slate.Sections();
  sections.register('header', theme.HeaderSection);
  sections.register('footer', theme.FooterSection);
  sections.register('map', theme.Maps);
  sections.register('instagram-feed', theme.InstagramFeed);
  sections.register('slideshow', theme.Slideshow);
  sections.register('quotes', theme.Quotes);
  sections.register('collection-template', theme.Collection);
  sections.register('list-collections-template', theme.ListCollections);
  sections.register('search-template', theme.Search);
  sections.register('article-template', theme.Article);
  sections.register('page-template', theme.Page);
  sections.register('password-template', theme.Password);
  sections.register('cart-template', theme.Cart);
  sections.register('product-template', theme.Product);

  // Templates
  new theme.Customers();

  // Globals
  // Sweettooth links
  $('a[href*="#sweettooth"]').attr('data-st-intent', 'st:core:home');

  // Common a11y fixes
  slate.a11y.pageLinkFocus($(window.location.hash));

  $('.in-page-link').on('click', function(evt) {
    slate.a11y.pageLinkFocus($(evt.currentTarget.hash));
  });

  $('a[href="#"]').on('click', function(evt) {
    evt.preventDefault();
  });

  slate.rte.wrapTable();
  slate.rte.iframeReset();
  slate.forms.initCustomSelects();
  slate.forms.initContactForms();
});